import * as previewLogics from '../preview/logics';
import * as textActions from '../text/actions';
import * as textLogics from '../text/logics';

import {
  ACTION_DESIGNLATER,
  ACTION_EDIT,
  ACTION_EDITCARTUPSELLS,
  ACTION_EDITTEMPLATE,
  ACTION_NEW,
  ACTION_REORDEREDIT,
  ACTION_SHIPPING,
  ACTION_VIRTUALPROOF,
  NAVINK_RETURNURL,
  PARAMETER_ACCTID,
  PARAMETER_COMPANYNAME,
  PARAMETER_CONTACTNUMBER,
  PARAMETER_COUPON,
  PARAMETER_DISPLAYITEMSKU,
  PARAMETER_EDITITEM,
  PARAMETER_EXACTREORDER,
  PARAMETER_IMPRINTAREACODE,
  PARAMETER_IMPRINTLOCATION,
  PARAMETER_INTCMP,
  PARAMETER_ISAS400REORDER,
  PARAMETER_ITEMSKU,
  PARAMETER_OLDCONFIGID,
  PARAMETER_OLDCONFIGID_KEY,
  PARAMETER_ORDERID,
  PARAMETER_ORDERSEQUENCE,
  PARAMETER_PRICESVCURL,
  PARAMETER_REFID,
  PARAMETER_REP,
  PARAMETER_REQUIREDUPSELLITEMID,
  PARAMETER_REQUIREDUPSELLSONLY,
  PARAMETER_RETURNURL,
  PARAMETER_SAMPLE,
  PARAMETER_SCID,
  PARAMETER_SESSIONID,
  PARAMETER_SHOPPINGCARTID,
  PARAMETER_STATUS,
  PARAMETER_TEMPLATEID,
  PARAMETER_TOKEN,
  PARAMETER_VENDORID,
  PARAMETER_ZIP,
  TRUE,
  configuratorAction,
  configuratorStep,
  deviceValue,
  errorInfoExclude,
  imprintOptionStep,
  internalBrands,
  internalServerExceptionCode,
  internalServerExceptionMessage,
  parameterName,
  promoStudioUITypeValue,
  reorderResultType,
  studioItemType,
} from './constants';
import {
  CANVAS_IMPRINT_TOO_CLOSE,
  ITEM_CANNOT_CUSTOMIZED,
  RESOURCES_PATH,
  elementStatus,
  hostVendorDict,
  imprintOptionText,
  imprintOptionType,
  jumpLinkType,
  modalType,
  nextBtnEvent,
  nextBtnId,
  pageUrl,
  processButtonDict,
  processButtonType,
  responseType,
  scene7StockImageMode,
  sidebarTabKeyEnum,
  undoRedoType,
  userImageType,
  vendorDict,
  vendorId,
} from './../utils/constants';
import {
  IMPRINT_COLOR_GROUP_INVALID_MESSAGE,
  IMPRINT_COLOR_INVALID_MESSAGE,
  IMPRINT_LOCATION_OPTION_INVALID_MESSAGE,
  IMPRINT_OPTION_INVALID_MESSAGE,
} from '../imprintarea/constants';
import { SAVED_GRID_PAGESIZE as SAVED_GRID_PAGESIZE_nextgen, nextGenFlyoutPanelEnum } from '../nextgen/constants.js';
import { SelectionType, YearOptionPricingType, YearQuestionCode } from '../bom/constants';
import { addBackgorundToRecent, addFeatureBackgroundToRecent } from '../template/logics.js';
import {
  addInitImageElements,
  initBackground,
  initCanvas,
  initImageDict,
  switchAskIfUserNeedImprintOption,
} from '../canvas/actions';
import {
  addToCartData,
  adminEditorAddToCartData,
  checkReturnUrl,
  getBomOptionsData,
  getCartData,
  getCartUpsellsData,
  getCartXml,
  getImprintThumbnails,
  getPricingData,
  getPromoStudioUIType,
  getScene7StockImageModeData,
  getStep1Data,
  getStep2Data,
  getToken as getTokenApi,
  getVendor,
  recordErrorInfo,
  sendOfflineChatEmail,
  updateCartUpsellsData,
} from './apis';
import {
  applyCurrentImprintColorToOtherOptionAsync,
  defaultImprintColorAsync,
  getAllSelectedImprintAreaKeysFromImprintAreasCombinedDict,
  imprintAreaSelectedAutomatic,
  imprintAreasInitAsync,
  imprintAreasResetAsync,
  imprintColorInitAsync,
  imprintOptionAssembleAsync,
  logoLayoutInitAsync,
  makeSelectionAutoAsync,
  mobileGuideModeSetupAsync,
  negativeMobileGuideModeAsync,
  nextgenUiSelectImprintArea,
  outsideUserImageMatch,
  pmsColorValidation,
  recordImprintOptionAutoAsync,
  recordTextColorAsync,
  recordUserImageSetupAsync,
  textLayoutInitAsync,
  textLayoutSelectAsync,
} from '../imprintarea/logics';
import {
  askIfUserNeedImprintText,
  backupStockImageType,
  changeInitializedImprintAreaKeys,
  finishOfflineChat,
  hideTransparencyCover,
  hideWaitingCover,
  imprintOptionUIInitialize,
  imprintOptionUISet,
  initializeActiveCart,
  initializeBomPreview,
  initializeCartUseScene7Template,
  initializeCharges,
  initializeDetailInfo,
  initializeImprintAreaDimension,
  initializeItemSpec,
  initializeNavInkPreconfigurationParameters,
  initializeOrder,
  initializeSaveProject,
  initializeShipping,
  initializeSpecialSymbols,
  initializeTemplatePreviewDict,
  initializeTrackingPixelScript,
  initializeUser,
  initializeVendor,
  isValidReturnUrl,
  saveProjectData,
  sendOfflineChatError,
  setBeforeUnloadListen,
  setCurrentAskNeedImprintOptionInfo,
  setCurrentImprintAreaKey,
  setCurrentImprintOptionStep,
  setCurrentStep,
  setImprintGroups,
  setNeedImprintOptionMode,
  setParameterToken,
  showConfirmDialog,
  showMessageBox,
  showTransparencyCover,
  showWaitingCover,
  switchShowWarningMessageContainer,
} from './actions';
import {
  changeNextgenUiStatusToGetStarted,
  checkNoAddSpecialImage,
  moveToNextFromProductDetailsAsync,
} from '../nextgen/logics.js';
import { changeTab, getCurrentTabIndex } from '../canvas/components/DesktopCanvasTab/logics';
import { changeTemplateElement, selectUpsellFirstLineText } from '../text/logics';
import {
  clearCurrentActiveCommonTemplate,
  initializeBackgroundDesignPanelShownFlags,
  selectCategory,
  selectTemplate,
} from '../template/actions';
import { clearText, initNonDigitalText } from '../text/actions';
import {
  dispatchBomOptionsErrorEvent,
  dispatchBomOptionsLoadingCompletedEvent,
  selectDefaultOptionsForBomOptions,
  updateBomUniqueOptionsForParentChildQuestions,
} from '../bom/logics';
import {
  getAdminToolsHost,
  getCoupon,
  getCurrentActiveCommonTemplate,
  getCurrentAskNeedImprintOptionInfo,
  getCurrentGuideModeCheck,
  getCurrentImprintAreaKey,
  getCurrentImprintOptionStep,
  getCurrentStep,
  getCurrentUpsellItemId,
  getCurrentUpsellType,
  getDisplayItemSku,
  getExternalWaitingCoverId,
  getHasUpsells,
  getInitializedImprintAreaKeys,
  getIsAdminEditReorder,
  getIsAllowDesignLater,
  getIsImprintRequired,
  getIsNavinkPlug,
  getItemId,
  getNeedImprintOptionModeCheck,
  getNeedValidateInterval,
  getOrder,
  getParameters,
  getPriceSvcUrl,
  getRefId,
  getReturnUrl,
  getSample,
  getSaveProject,
  getSelectedUpsells,
  getShipping,
  getSidebarTabKey,
  getStatus,
  getStockImageTypeDict,
  getStudioItemType,
  getTecSysItemFlag,
  getTempBackgroundImage,
  getTemplateId,
  getToken,
  getTwinItemId,
  getUser,
  getUserCompanyName,
  getVendorId,
  getZipCode,
  isInternalBrand,
} from './selectors';
import {
  getAllAppliedImprintAreaKeys,
  getAllImprintOptionUI,
  getAllNextGenUIImprintAreaKeys,
  getAllSelectedImprintAreaKeys,
  getCurrentImprintOptionUI,
  getCurrentTextLayout,
  hasMissingInMultipleGroups as getHasMissingInMultipleGroups,
  getHasOneImprintColorOnly,
  getHasOnlyOneCombinationAndNotNoImprint,
  hasOnlyOneImprintArea as getHasOnlyOneImprintArea,
  getImprintAreasInit,
  getImprintOptionOfferLogo,
  getImprintOptionOfferSlogan,
  getImprintOptionType,
  getImprintOptionTypeLayout,
  isImprintAreaNoneSelected as getIsImprintAreaNoneSelected,
  getMakeSelectionAutoCheck,
  getOpitonalText,
  getSelectedImprintAreaKeys,
  getSelectedImprintAreas,
  getSelectedImprintLocation,
  getSelectedLogoLocation,
  getTempSelectedImprintAreaKeys,
  getTempSelectedImprintAreas,
  getTextLayoutInitialization,
  getUninitializedImprintAreas,
  getUninitializedImprintLocation,
  getUninitializedLogoLocation,
  getUserImageSetupCheck,
  hasTextImprintOptionType,
  isAllTempSelectedImprintAreaNoImprint,
} from '../imprintarea/selectors';
import {
  getAllQuestions,
  getAllUniqueOptions,
  getBomOptionsValidation,
  getBomOptionsValidationOffFlagFromParameters,
  getFinalBomOptionsSelection,
  getHasNoImprintOptionsFlagFromParameters,
  getQuestion,
  getUniqueOptions,
  getUpdatePreselectionRequest,
  getWhetherCurrentContextIsBomOptionsPackage,
} from '../bom/selectors';
import { getCanvasImageDataDictForAddCart, getMissingNonDigitalOptionType, getTempElement } from '../canvas/selectors';
import { getChildItemIdFromBomSelectionForLite, getIsLiteParentChildItem } from '../lite/selectors';
import { getFullPreviewDict, getLiteSelectedColorBomOptions, getSelectedColorBomOptions } from '../preview/selectors';
import {
  getIfUserNeedImprintText,
  getSelectedCustomizableUpsellItemIds,
  getUpsellImprintTextList,
  getUpsellsValidation,
  getWhetherHasOptionalUpsellsOrNot,
} from '../upsell/selectors';
import { getImprintedTextDataDict, getScaleDict, getTextDataDict } from '../text/selectors';
import {
  getSavedArtCount,
  getSavedArtListByPage,
  getSentimentList,
  getSharedArtList,
  getSloganList,
  getStockArtCategories,
  getVerseList,
  initMandatorySingleUserImage,
  userImageAssembleAsync,
  userImageMandatoryMissingCheckAsync,
} from '../userimage/logics';
import {
  getSavedArtDict as getSavedArtDictSelector,
  getSentimentList as getSentimentListSelector,
  getSharedArtDict as getSharedArtDictSelector,
  getUserImageAccess,
  getVerseList as getVerseListSelector,
} from '../userimage/selectors';
import { imprintOptionTypeInit, imprintThumbnailInitialize } from '../imprintarea/actions';
import { initDefaultUrlIndex, initMoreviews } from '../preview/actions';
import {
  initializeChildOptions,
  initializeQuantity,
  initializeQuestions,
  initializeRelations,
  initializeSizeChart,
  initializeUniqueOptions,
  initializeUniqueOptionsBackup,
} from '../bom/actions';
import {
  initializeLiteBomOptionsData,
  initializeLiteCartData,
  initializeLiteData,
  validateLiteImprintAreaSelected,
} from '../lite/logics';
import {
  initializeUpsells,
  setCurrentUpsellItemId,
  setCurrentUpsellType,
  setCurrentUpsellsValidationStatus,
  setOptionalUpsellsExcluded,
} from '../upsell/actions';
import { isIntervalInvalid, resizeWindow, validateImageDpiBeforeAddCart } from '../canvas/logics';
import { nextgenProductDetailModels, nextgenUiStepButtons, nextgenUiSteps } from './constants';
import { studioItemType as studioItemTypeEnum, validateResultMessage } from './constants';

import { FastLayer } from 'react-konva';
import { GoogleTagManager } from '../utils/aop.js';
import { SAVED_GRID_PAGESIZE } from '../userimage/constants';
import { ThumbnailType } from '../bom/constants';
import { UpsellType } from '../upsell/constants';
import { applyNoticeToggle } from '../userimage/actions';
import { changeSideBarKey } from '../sidebar/logics';
import { changeSidebarTabKey } from '../sidebar/actions';
import { getAllGroupImprintAreas } from '../imprintarea/selectors';
import { getAllInitData } from './apis';
import { getAllowedIcons } from '../sidebar/selectors';
import { getFinalTemplateSelection } from '../template/selectors';
import { getFontFiles } from './apis';
import { getIsNextGenUI } from '../nextgen/selectors.js';
import { getPrice } from '../price/selectors';
import { getProjectData } from './../utils/selectors';
import { getPromoStudioUIType as getPromoStudioUITypeSelector } from '../lite/selectors';
import { getSidebarStoreData } from '../sidebar/selectors';
import { getTextLine } from '../text/selectors';
import { getUpsellData } from './apis';
import { push as go } from 'redux-first-history';
import { initNextgenStepSettings } from '../nextgen/actions.js';
import { initializePrice } from '../price/actions';
import { isMobileOnly } from 'react-device-detect';
import { nextGenImprintAreaSelectedAsync } from '../imprintarea/logics';
import { nextgenUiFinalSelectImprintAreas } from '../imprintarea/logics';
import { pushToUndoList } from '../canvas/components/UndoRedo/logic';
import { setCurrentBomOption } from '../nextgen/actions.js';
import { setLogoEditingStatusToPreview } from '../uploadimage/logics';
import { setProductDetailsInterfaceSettings } from '../nextgen/actions.js';
import { setSavedArtList } from '../nextgen/Upload/logics.js';
import { showModal } from '../tools/actions';
import { showProductDetailsAsync } from '../nextgen/product/logics.js';
import { switchShowPreviewWindow } from '../nextgen/actions.js';
import template from '../template';
import { v4 as uuidv4 } from 'uuid';
import { validateImprintRequiredResult } from '../nextgen/constants.js';

export const showWarningMessageContainer = (messageArray) => (dispatch) => {
  dispatch(
    switchShowWarningMessageContainer({
      show: true,
      message: messageArray,
    })
  );
  isMobileOnly && dispatch(setCurrentStep(configuratorStep.warning));
};

export const showMissingImprintOptionwarningMessage = (missingImprintOptionTypeObj) => (dispatch, getState) => {
  const state = getState();
  const currentStudioItemType = getStudioItemType(state);
  const isLite = getPromoStudioUITypeSelector(state) === promoStudioUITypeValue.LiteUI;
  let message = [];
  if (currentStudioItemType === studioItemTypeEnum.nonDigital) {
    if (missingImprintOptionTypeObj) {
      const isMakeSelectionAuto = getMakeSelectionAutoCheck(state, missingImprintOptionTypeObj.imprintAreaDescription);
      const isStandard = missingImprintOptionTypeObj.imprintAreaDescription === 'Standard';
      let textLine1 = `You have not added your ${missingImprintOptionTypeObj.optionText}${
        isStandard ? '' : ` to the ${missingImprintOptionTypeObj.imprintAreaDescription}`
      }.`;
      let textLine2 = '';
      if (missingImprintOptionTypeObj.askNeedImprintOption) {
        dispatch(switchAskIfUserNeedImprintOption(true));
        textLine1 = textLine1 + ' Please make a selection below.';
      } else if (!isMakeSelectionAuto && !isLite) {
        textLine2 = isMobileOnly
          ? `Please add your ${missingImprintOptionTypeObj.optionText} or press the "Imprint Options" button at the top of the studio to edit your selection.`
          : `Please add your ${missingImprintOptionTypeObj.optionText} or press the "Return to Imprint Options" button at the bottom of the screen to change your imprint type.`;
      }
      message.push(textLine1, textLine2);
      dispatch(showWarningMessageContainer(message));
      dispatch(setCurrentAskNeedImprintOptionInfo(missingImprintOptionTypeObj));
      dispatch(hideWaitingCover());
    }
  }
};

export const validateCurrentImprintAreaCanvasData = (imprintAreaKey) => (dispatch, getState) => {
  const state = getState();
  const needImprintOptionModeCheck = getNeedImprintOptionModeCheck(state);
  const missingImprintOptionTypeObj = getMissingNonDigitalOptionType(state, imprintAreaKey);
  if (
    missingImprintOptionTypeObj.optionText &&
    ((missingImprintOptionTypeObj.askNeedImprintOption && needImprintOptionModeCheck) ||
      !missingImprintOptionTypeObj.askNeedImprintOption)
  ) {
    dispatch(showMissingImprintOptionwarningMessage(missingImprintOptionTypeObj));
    return false;
  } else {
    return true;
  }
};

export const validateAllImprintAreaCanvasData = () => (dispatch, getState) => {
  const state = getState();
  const selectedImprintAreaKeys = getSelectedImprintAreaKeys(state);
  const isLite = getPromoStudioUITypeSelector(state) === promoStudioUITypeValue.LiteUI;
  for (const imprintAreaKey of selectedImprintAreaKeys) {
    const needImprintOptionModeCheck = getNeedImprintOptionModeCheck(state, imprintAreaKey);
    const missingImprintOptionTypeObj = getMissingNonDigitalOptionType(state, imprintAreaKey);
    if (missingImprintOptionTypeObj.optionText && (needImprintOptionModeCheck || isLite)) {
      const isNextGenUI = getIsNextGenUI(state);
      if (isNextGenUI) {
        dispatch(
          showMessageBox({
            show: true,
            message: missingImprintOptionTypeObj,
          })
        );
      } else {
        dispatch(showMissingImprintOptionwarningMessage(missingImprintOptionTypeObj));
      }

      return false;
    }
  }
  return true;
};

export const validateImageDpi = () => (dispatch, getState) => {
  const state = getState();
  const currentStudioItemType = getStudioItemType(state);
  if (currentStudioItemType === studioItemTypeEnum.digital) {
    return validateImageDpiBeforeAddCart(dispatch, state);
  }

  return true;
};

export const initailizeNeedImprintOptionMode = () => (dispatch, getState) => {
  const state = getState();
  const selectedImprintAreaKeys = getSelectedImprintAreaKeys(state);
  const payload = {};
  for (const imprintAreaKey of selectedImprintAreaKeys) {
    if (state.ui.needImprintOptionMode[imprintAreaKey] === undefined) payload[imprintAreaKey] = true;
    else {
      payload[imprintAreaKey] = true;
      break;
    }
  }
  dispatch(setNeedImprintOptionMode(payload));
};

export const switchNeedImprintOptionMode =
  ({ imprintAreaKey, isCheck }) =>
  (dispatch) => {
    const payload = {};
    payload[imprintAreaKey] = isCheck;
    dispatch(setNeedImprintOptionMode(payload));
  };

export const verifyAndSwitchSteps =
  ({ nextStep, resolve }) =>
  (dispatch, getState) => {
    const state = getState();
    const currentStep = getCurrentStep(state);
    const currentStudioItemType = getStudioItemType(state);
    const switchAction = () => {
      resolve && typeof resolve === 'function'
        ? resolve()
        : nextStep !== undefined && dispatch(setCurrentStep(nextStep));
    };
    if (currentStep === configuratorStep.canvas) {
      if (
        currentStudioItemType === studioItemTypeEnum.digital ||
        currentStudioItemType === studioItemTypeEnum.screenPrintedDigital
      ) {
        switchAction();
      } else {
        const successCallback = function () {
          dispatch(hideWaitingCover());
          switchAction();
        };
        dispatch(textLogics.invalidCharactersRetrieval());
        dispatch(textLogics.updateNonDigitalFullPreview({ successCallback }));
      }
    } else {
      switchAction();
    }
  };

const resizingAfterSideChanged = () => (dispatch) => {
  setTimeout(() => {
    dispatch(resizeWindow());
  }, 500);
};

const onCancelClick = (previousStep) => (dispatch) => {
  dispatch(setCurrentStep(previousStep));
};

const onTemplateCancelClick = (previousStep) => (dispatch) => {
  dispatch(clearCurrentActiveCommonTemplate());
  dispatch(setCurrentStep(previousStep));
  if (isMobileOnly) {
    dispatch(changeSidebarTabKey(sidebarTabKeyEnum.WhatsNext));
  }
};

export const onNoThanksClick = () => (dispatch) => {
  dispatch(showWaitingCover());
  dispatch(setOptionalUpsellsExcluded());
  dispatch(addToCart());
};

export const onNoWantTextClick = (successCallback, failureCallback) => (dispatch) => {
  dispatch(showWaitingCover());
  dispatch(
    upsellCustomizationFinished({
      successCallback,
      failureCallback,
      noWantAddText: true,
    })
  );
};

export const onUpsellCustomizationClick = (askIfUserNeedUpsellImprintText) => (dispatch) => {
  if (isMobileOnly) {
    dispatch(onNoThanksClick());
  } else {
    if (askIfUserNeedUpsellImprintText) {
      dispatch(onNoWantTextClick());
    } else {
      dispatch(onNoThanksClick());
    }
  }
};
export const onNextClick = () => (dispatch, getState) => {
  const state = getState();
  const currentStep = getCurrentStep(state);
  dispatch(showWaitingCover());
  dispatch(mainProcess[currentStep].next());
};

export const onClickAddToCartButtonForCartUpsells = (successCallback, failureCallback) => (dispatch, getState) => {
  const state = getState();
  const currentStep = getCurrentStep(state);

  dispatch(showWaitingCover());
  if (currentStep === configuratorStep.upsell) {
    dispatch(upsellFinished(successCallback, failureCallback));
  } else if (currentStep === configuratorStep.upsellCustomization) {
    dispatch(upsellCustomizationFinished({ successCallback, failureCallback }));
  }
};

export const previousClickHandler = () => (dispatch) => {
  dispatch((_, getState) => {
    const curState = getState();
    const tempSelectedImprintAreaKeys = getTempSelectedImprintAreaKeys(curState);
    const hasOnlyOneImprintArea = getHasOnlyOneImprintArea(curState);
    const currentImprintAreaKey = getCurrentImprintAreaKey(curState);
    const currentImprintOptionStep = getCurrentImprintOptionStep(curState);
    let imprintOptionIndex = tempSelectedImprintAreaKeys.indexOf(currentImprintAreaKey);

    switch (currentImprintOptionStep) {
      case imprintOptionStep.Layout: {
        while (true) {
          if (imprintOptionIndex === 0) {
            if (hasOnlyOneImprintArea) {
              dispatch(setCurrentStep(configuratorStep.bom));
            } else {
              dispatch(setCurrentStep(configuratorStep.imprintarea));
              dispatch(whetherAutoSkipImprintAreaPage(true));
            }
            break;
          } else {
            const preFormatKey = tempSelectedImprintAreaKeys[imprintOptionIndex - 1];
            const isMakeSelectionAuto = getMakeSelectionAutoCheck(curState, preFormatKey);
            if (isMakeSelectionAuto) {
              dispatch(recordImprintOptionAutoAsync(preFormatKey));
              imprintOptionIndex -= 1;
            } else {
              dispatch(setCurrentImprintAreaKey(preFormatKey));
              dispatch(setCurrentImprintOptionStep(imprintOptionStep.Layout));
              dispatch(hideWaitingCover());
              dispatch(whetherAutoSkipImprintOptionPage(true));
              break;
            }
          }
        }
        break;
      }
      case imprintOptionStep.TextColor: {
        dispatch(setCurrentImprintOptionStep(imprintOptionStep.Layout));
        dispatch(hideWaitingCover());
        dispatch(whetherAutoSkipImprintOptionPage(true));
        break;
      }
    }
  });
};

const bomFinished = () => (dispatch, getState) => {
  const state = getState();
  const validation = getBomOptionsValidation(state);
  const isSample = getSample(state);
  const imprintAreas = getImprintAreasInit(state).formats;
  const allowDesignLater = getIsAllowDesignLater(state);
  const hasUpsells = getHasUpsells(state);
  if (validation.isValid) {
    if (isSample) dispatch(addToCart());
    else if (Object.keys(imprintAreas).length === 0 || allowDesignLater)
      dispatch(
        goToUpsellOrAddToCart({
          hasUpsells,
          addToCartDirectly: true,
          allowDesignLater,
        })
      );
    else dispatch(ForwardToImprintOptionSelectAsync());
  } else {
    dispatch(showWarningMessageContainer([validation.message]));
    dispatch(hideWaitingCover());
  }
};

export const nextgenBomFinished = () => (dispatch, getState) => {
  const state = getState();
  const isAdminEditOrder = getIsAdminEditReorder(state);

  // Admin Edit Order shoule keep the orginal imprint areas
  // Normal Step should remove uncusomized imprint areas
  if (!isAdminEditOrder) {
    dispatch(nextgenUiFinalSelectImprintAreas());
  }
  const validation = getBomOptionsValidation(state);
  const isSample = getSample(state);

  if (validation.isValid) {
    if (isSample) dispatch(addToCart());
    else {
      dispatch(nextgenUiGoToUpsellOrAddToCart());
    }
  } else {
    //dispatch(showWarningMessageContainer([validation.message]));
    dispatch(
      showMessageBox({
        show: true,
        message: validation.message,
      })
    );
    dispatch(hideWaitingCover());
  }
};

const whetherAutoSkipImprintAreaPage =
  (isPrev = false) =>
  (dispatch, getState) => {
    const state = getState();
    const { groups } = getImprintAreasInit(state);
    let isAutoSkip = true;
    for (let key in groups) {
      if (groups[key].combinations.length !== 1 || groups[key].combinations[0].selected === false) {
        isAutoSkip = false;
      }
    }
    if (isAutoSkip) {
      if (isPrev) {
        dispatch(setCurrentStep(configuratorStep.bom));
      } else {
        dispatch(onNextClick());
      }
    }
  };
const whetherAutoSkipImprintOptionPage =
  (isPrev = false) =>
  (dispatch, getState) => {
    const state = getState();
    const types = getImprintOptionTypeLayout(state);
    let isAutoSkip = true;
    const currentImprintAreaKey = getCurrentImprintAreaKey(state);
    const currentImprintOptionType = getImprintOptionType(state, currentImprintAreaKey);

    if (types.length !== 1 || types[0].selected === false) {
      isAutoSkip = false;
    } else {
      if (isMobileOnly && currentImprintOptionType === imprintOptionType.TextOnly) {
        isAutoSkip = false;
      }
    }
    if (isAutoSkip) {
      if (isPrev) {
        dispatch(previousClickHandler());
      } else {
        dispatch(onNextClick());
      }
    }
  };
// ImprintArea - start
const imprintareaFinished = () => (dispatch, getState) => {
  const state = getState();
  const hasMissingInMultipleGroups = getHasMissingInMultipleGroups(state);
  const allSelectedImprintAreaKeys = getAllSelectedImprintAreaKeys(state);
  const isImprintAreaNoneSelected = getIsImprintAreaNoneSelected(state);
  const currentStudioItemType = getStudioItemType(state);
  const hasUpsells = getHasUpsells(state);

  const validation = getBomOptionsValidation(state);
  if (!validation.isValid) {
    dispatch(showWarningMessageContainer([validation.message]));
    dispatch(hideWaitingCover());
  } else {
    //Please make a selection in each group of imprint locations.
    //Please make a selection in the imprint location options.
    if (hasMissingInMultipleGroups) {
      dispatch(hideWaitingCover());
      dispatch(showWarningMessageContainer([IMPRINT_COLOR_GROUP_INVALID_MESSAGE]));
    } else {
      if (allSelectedImprintAreaKeys.length > 0) {
        if (isImprintAreaNoneSelected) {
          dispatch(goToUpsellOrAddToCart({ hasUpsells, addToCartDirectly: true }));
        } else {
          switch (currentStudioItemType) {
            case studioItemType.digital:
            case studioItemType.screenPrintedDigital: {
              dispatch(gotoStep2());
              break;
            }
            case studioItemType.nonDigital: {
              const curState = getState();
              const tempSelectedImprintAreaKeys = getTempSelectedImprintAreaKeys(curState);
              let imprintOptionIndex = 0;
              while (true) {
                const nextFormatKey = tempSelectedImprintAreaKeys[imprintOptionIndex];
                const isMakeSelectionAuto = getMakeSelectionAutoCheck(curState, nextFormatKey);
                if (isMakeSelectionAuto) {
                  dispatch(recordImprintOptionAutoAsync(nextFormatKey));
                  dispatch(makeSelectionAutoAsync(nextFormatKey));
                  imprintOptionIndex += 1;
                  if (imprintOptionIndex === tempSelectedImprintAreaKeys.length) {
                    dispatch(gotoStep2());
                    break;
                  }
                } else {
                  dispatch(setCurrentImprintAreaKey(nextFormatKey));
                  dispatch(setCurrentStep(configuratorStep.imprintoption));
                  dispatch(setCurrentImprintOptionStep(imprintOptionStep.Layout));
                  dispatch(hideWaitingCover());
                  dispatch(whetherAutoSkipImprintOptionPage());
                  break;
                }
              }
              break;
            }
          }
        }
      } else {
        dispatch(hideWaitingCover());
        dispatch(showWarningMessageContainer([IMPRINT_LOCATION_OPTION_INVALID_MESSAGE]));
      }
    }
  }
};
// ImprintArea - end

// ImprintOption - start
const imprintoptionFinished = () => (dispatch, getState) => {
  const state = getState();
  const tempSelectedImprintAreaKeys = getTempSelectedImprintAreaKeys(state);
  const currentImprintAreaKey = getCurrentImprintAreaKey(state);
  const isAllNoImprintChosen = isAllTempSelectedImprintAreaNoImprint(state);
  const hasUpsells = getHasUpsells(state);
  const hasOnlyOneImprintColor = getHasOneImprintColorOnly(state, currentImprintAreaKey);
  const currentImprintOptionStep = getCurrentImprintOptionStep(state);
  const initializedImprintAreaKeys = getInitializedImprintAreaKeys(state);
  let imprintOptionIndex = tempSelectedImprintAreaKeys.indexOf(currentImprintAreaKey);

  const textDictAndImageDictSetup = () => {
    const initNonDigitalTextAction = (key) => {
      if (
        !(state.textDict && state.textDict[key] && state.textDict[key].length > 0) &&
        initializedImprintAreaKeys.indexOf(key) > -1
      ) {
        const textLines = getTextLine(key)(getState());
        textLines && dispatch(initNonDigitalText(textLines));
      }
    };

    tempSelectedImprintAreaKeys.forEach((key) => {
      const _type = getImprintOptionType(state, key);
      switch (_type) {
        case imprintOptionType.TextOnly: {
          //keep OutSideImage
          if (state.imageDict && state.imageDict[key]) {
            const justOutSideImage = state.imageDict[key].filter((x) => outsideUserImageMatch(x.data));
            dispatch(initImageDict({ key, images: justOutSideImage }));
          }
          initNonDigitalTextAction(key);
          break;
        }
        case imprintOptionType.LogoOnly: {
          dispatch(clearText({ imprintAreaKey: key }));
          break;
        }
        case imprintOptionType.TextLogo: {
          initNonDigitalTextAction(key);
          break;
        }
        case imprintOptionType.NoImprint: {
          dispatch(initImageDict({ key, images: [] }));
          dispatch(clearText({ imprintAreaKey: key }));
          break;
        }
        //there won't be case imprintOptionType.NA
        //avoid eslint warning to add default case - default-case
        default: {
          break;
        }
      }
    });
  };

  const imprintOptionFinalizeProcess = () => {
    while (true) {
      if (imprintOptionIndex + 1 === tempSelectedImprintAreaKeys.length) {
        // set up textDict and imageDict for Step2
        textDictAndImageDictSetup();

        if (isAllNoImprintChosen) {
          dispatch(goToUpsellOrAddToCart({ hasUpsells, addToCartDirectly: true }));
        } else {
          dispatch(gotoStep2());
        }
        break;
      } else {
        const nextFormatKey = tempSelectedImprintAreaKeys[imprintOptionIndex + 1];
        const isMakeSelectionAuto = getMakeSelectionAutoCheck(state, nextFormatKey);
        if (isMakeSelectionAuto) {
          dispatch(recordImprintOptionAutoAsync(nextFormatKey));
          dispatch(makeSelectionAutoAsync(nextFormatKey));
          imprintOptionIndex += 1;
        } else {
          dispatch(setCurrentImprintAreaKey(nextFormatKey));
          dispatch(setCurrentImprintOptionStep(imprintOptionStep.Layout));
          dispatch(hideWaitingCover());
          dispatch(whetherAutoSkipImprintOptionPage());
          break;
        }
      }
    }
  };

  const imprintOptionLayoutProcess = (nextAction) => {
    const currentImprintOptionType = getImprintOptionType(state, currentImprintAreaKey);
    if (currentImprintOptionType === imprintOptionType.NA) {
      dispatch(showWarningMessageContainer([IMPRINT_OPTION_INVALID_MESSAGE]));
      dispatch(hideWaitingCover());
    } else if (currentImprintOptionType === imprintOptionType.NoImprint) {
      imprintOptionFinalizeProcess(state);
    } else {
      // ImprintLocation Selected check
      const currentTextLayout = getCurrentTextLayout(state);
      if (
        currentImprintOptionType !== imprintOptionType.NA &&
        currentImprintOptionType !== imprintOptionType.NoImprint &&
        !currentTextLayout
      ) {
        const textLayoutList = getTextLayoutInitialization(state);
        let error_msg = '';
        if (textLayoutList.length === 1) {
          error_msg = 'auto selected wrong';
        } else if (textLayoutList.length > 1) {
          error_msg = 'no selected wrong';
        }
        dispatch(
          catchErrorInfo({
            message: `[${currentImprintAreaKey}]-ImprintLocation Missing: ${error_msg}`,
          })
        );
        if (textLayoutList.length >= 1) {
          dispatch(textLayoutSelectAsync(currentImprintAreaKey, textLayoutList[0]));
        }
      }

      if (hasOnlyOneImprintColor) {
        //imprint color default
        dispatch(defaultImprintColorAsync(currentImprintAreaKey));
        imprintOptionFinalizeProcess(state);
      } else {
        if (currentImprintOptionType !== imprintOptionType.LogoOnly) {
          nextAction && nextAction();
        } else {
          imprintOptionFinalizeProcess(state);
        }
      }
    }
  };

  const imprintOptionTextColorProcess = () => {
    const curImprintOption = getCurrentImprintOptionUI(state, currentImprintAreaKey);
    if (!curImprintOption || !curImprintOption.textColor) {
      dispatch(showWarningMessageContainer([IMPRINT_COLOR_INVALID_MESSAGE]));
      dispatch(hideWaitingCover());
    } else {
      const pmsChecked = pmsColorValidation(dispatch, curImprintOption.textColor);
      if (pmsChecked.valid) {
        imprintOptionIndex === 0 && dispatch(applyCurrentImprintColorToOtherOptionAsync(curImprintOption.textColor));
        imprintOptionFinalizeProcess(state);
      } else {
        dispatch(hideWaitingCover());
        dispatch(showWarningMessageContainer([pmsChecked.message]));
      }
    }
  };

  if (isMobileOnly) {
    imprintOptionLayoutProcess(imprintOptionTextColorProcess);
  } else {
    switch (currentImprintOptionStep) {
      case imprintOptionStep.Layout: {
        imprintOptionLayoutProcess(() => {
          dispatch(setCurrentImprintOptionStep(imprintOptionStep.TextColor));
          dispatch(hideWaitingCover());
        });
        break;
      }
      case imprintOptionStep.TextColor: {
        imprintOptionTextColorProcess();
        break;
      }
    }
  }
};
// ImprintOption - end

export const canvasFinished = () => (dispatch, getState) => {
  const state = getState();
  const currentImprintAreaKey = getCurrentImprintAreaKey(state);

  const status = getStatus(state);
  const isVirtualProof = getConfiguratorAction(status) === configuratorAction.virtualProof;

  if (isVirtualProof) {
    dispatch(hideWaitingCover());
    dispatch(GoogleTagManager(() => dispatch(showModal(modalType.Email)), 'Studio_Email Preview'));
  } else {
    dispatch(
      userImageMandatoryMissingCheckAsync({
        formatkey: currentImprintAreaKey,
        resolve: () => {
          const selectedImprintAreaKeys = getSelectedImprintAreaKeys(state);
          const currentImprintAreaKey = getCurrentImprintAreaKey(state);
          const canvasIndex = selectedImprintAreaKeys.indexOf(currentImprintAreaKey);
          const lastImprintArea = canvasIndex === selectedImprintAreaKeys.length - 1;
          const hasUpsells = getHasUpsells(state);
          const tempElement = getTempElement(state);
          const tempBackgroundImage = getTempBackgroundImage(state);
          const currentStudioItemType = getStudioItemType(state);
          const needValidateInterval = getNeedValidateInterval(state);

          if (selectedImprintAreaKeys.length === 1 || lastImprintArea) {
            dispatch(goToUpsellOrAddToCart({ hasUpsells, addToCartDirectly: false }));
            return;
          }

          if (tempElement || (tempBackgroundImage && tempBackgroundImage.data)) {
            dispatch(applyNoticeToggle({ show: true, keepPromptText: true }));
            dispatch(hideWaitingCover());
            return;
          }

          if (
            currentStudioItemType === studioItemType.digital ||
            currentStudioItemType === studioItemType.screenPrintedDigital
          ) {
            if (
              currentStudioItemType === studioItemType.screenPrintedDigital &&
              needValidateInterval &&
              dispatch(isIntervalInvalid())
            ) {
              dispatch(showWarningMessageContainer([CANVAS_IMPRINT_TOO_CLOSE]));
            } else {
              dispatch(previewLogics.updateFullPreview());
              dispatch(setCurrentImprintAreaKey(selectedImprintAreaKeys[canvasIndex + 1]));
              dispatch(resizingAfterSideChanged());
            }
          } else if (currentStudioItemType === studioItemType.nonDigital) {
            //update full preview when switching the imprint side tabs
            const finallyCallback = function () {
              if (dispatch(validateCurrentImprintAreaCanvasData(currentImprintAreaKey))) {
                dispatch(setCurrentImprintAreaKey(selectedImprintAreaKeys[canvasIndex + 1]));
                dispatch(
                  switchNeedImprintOptionMode({
                    imprintAreaKey: selectedImprintAreaKeys[canvasIndex + 1],
                    isCheck: true,
                  })
                );
                dispatch(resizingAfterSideChanged());
                isMobileOnly && dispatch(mobileSide2GuideStartAsync());

                dispatch(textLogics.updateTheSecondTabOnce());
                dispatch(previewLogics.updateFullPreview());
              }
            };
            dispatch(textLogics.invalidCharactersRetrieval());
            dispatch(
              textLogics.updateNonDigitalFullPreview({
                needUpdatePreview: true,
                finallyCallback,
              })
            );
          }
          dispatch(hideWaitingCover());
        },
        reject: (mandatory) => {
          dispatch(hideWaitingCover());
          dispatch(
            showMessageBox({
              show: true,
              message: mandatory.warning,
            })
          );
        },
      })
    );
  }
};

export const templateFinished = () => (dispatch, getState) => {
  const state = getState();
  const currentImprintAreaKey = getCurrentImprintAreaKey(state);
  const activeTemplate = getCurrentActiveCommonTemplate(state);
  //check if template selected
  //get text element from backend
  if (activeTemplate) {
    dispatch(selectCategory(currentImprintAreaKey, activeTemplate.categoryId));
    dispatch(selectTemplate(currentImprintAreaKey, activeTemplate.categoryId, activeTemplate.templateId));
    dispatch(changeTemplateElement(activeTemplate));
    dispatch(clearCurrentActiveCommonTemplate());
    dispatch(addBackgorundToRecent(activeTemplate));
  }
  dispatch(setCurrentStep(configuratorStep.canvas));
  if (isMobileOnly) dispatch(changeSidebarTabKey(sidebarTabKeyEnum.WhatsNext));
  dispatch(hideWaitingCover());
  dispatch(pushToUndoList(undoRedoType.ChangeTemplateOrEditElement));
  dispatch(previewLogics.updateFullPreview());
};

const upsellFinished = (successCallback, failureCallback) => (dispatch, getState) => {
  const state = getState();
  const upsellsValidation = getUpsellsValidation(state);
  const customizableUpsellItemIds = getSelectedCustomizableUpsellItemIds(state);
  const parameters = getParameters(state);
  const action = getConfiguratorAction(parameters[PARAMETER_STATUS]);
  const upsellType = getCurrentUpsellType(state);
  const hasOptionalUpsells = getWhetherHasOptionalUpsellsOrNot(state);
  if (upsellsValidation.isValid) {
    //let cartRequest = getCartRequest();
    dispatch(setCurrentUpsellsValidationStatus('', false));
    if (customizableUpsellItemIds.length > 0) {
      dispatch(setCurrentUpsellItemId(customizableUpsellItemIds[0]));
      dispatch(setCurrentStep(configuratorStep.upsellCustomization));
      dispatch(textLogics.updateUpsellImprintSizing());
      dispatch(hideWaitingCover());
    } else {
      if (upsellType === UpsellType.required && hasOptionalUpsells) {
        dispatch(setCurrentUpsellType(UpsellType.optional));
        dispatch(setCurrentUpsellItemId(''));
        dispatch(hideWaitingCover());
      } else {
        action === configuratorAction.editCartUpsells
          ? dispatch(updateCartUpsells(successCallback, failureCallback))
          : dispatch(addToCart());
      }
    }
  } else {
    dispatch(setCurrentUpsellsValidationStatus('', true));
    dispatch(hideWaitingCover());
  }
};

const upsellCustomizationFinished = function (props = {}) {
  return (dispatch, getState) => {
    const { successCallback, failureCallback, noWantAddText = false } = props;
    const state = getState();
    const customizableUpsellItemIds = getSelectedCustomizableUpsellItemIds(state);
    const currentUpsellItemId = getCurrentUpsellItemId(state);
    const currentUpsellIndex = customizableUpsellItemIds.indexOf(currentUpsellItemId);
    const lastUpsell = currentUpsellIndex === customizableUpsellItemIds.length - 1;
    const parameters = getParameters(state);
    const action = getConfiguratorAction(parameters[PARAMETER_STATUS]);
    const upsellType = getCurrentUpsellType(state);
    const hasOptionalUpsells = getWhetherHasOptionalUpsellsOrNot(state);
    const upsellImprintedTextList = getUpsellImprintTextList(state);
    const hasImprintText = upsellImprintedTextList !== undefined && upsellImprintedTextList.length > 0;
    const askIfUserNeedUpsellImprintText = getIfUserNeedImprintText(state);
    const isNextGenUI = getIsNextGenUI(state);
    if (hasImprintText || noWantAddText) {
      const imprintSizingSuccessCallback = function () {
        if (lastUpsell) {
          if (upsellType === UpsellType.required && hasOptionalUpsells) {
            dispatch(setCurrentStep(configuratorStep.upsell));
            dispatch(setCurrentUpsellType(UpsellType.optional));
            dispatch(setCurrentUpsellItemId(''));
            dispatch(hideWaitingCover());
          } else {
            action === configuratorAction.editCartUpsells
              ? dispatch(updateCartUpsells(successCallback, failureCallback))
              : dispatch(addToCart());
          }
        } else {
          dispatch(setCurrentUpsellItemId(customizableUpsellItemIds[currentUpsellIndex + 1]));
          dispatch(hideWaitingCover());
        }
      };
      dispatch(askIfUserNeedImprintText(false));
      dispatch(textLogics.invalidCharactersRetrieval({ fromUpsellText: true }));
      dispatch(
        textLogics.updateUpsellImprintSizing({
          successCallback: imprintSizingSuccessCallback,
        })
      );
      dispatch(selectUpsellFirstLineText());
    } else {
      // click the 'Add to Cart' button
      if (!askIfUserNeedUpsellImprintText) {
        if (action === configuratorAction.editCartUpsells || isNextGenUI) {
          dispatch(showMessageBox('You have not added text for your item. Please make a selection below.'));
        } else {
          dispatch(
            showWarningMessageContainer(['You have not added text for your item. Please make a selection below.'])
          );
        }
        dispatch(askIfUserNeedImprintText(true));
      } else {
        // click the 'I want to add text' button
        dispatch(askIfUserNeedImprintText(false));
        dispatch(switchShowWarningMessageContainer({ show: false }));
      }
      dispatch(hideWaitingCover());
    }
  };
};

const liteFinished = () => (dispatch, getState) => {
  const state = getState();
  const validation = getBomOptionsValidation(state);

  if (validation.isValid) {
    dispatch(addToCartLite());
  } else {
    dispatch(showMessageBox({ show: true, message: validation.message }));
    dispatch(hideWaitingCover());
  }
};

const updateShippingFinished = () => (dispatch) => {
  dispatch(updateShipping());
};

const mobileStep2BackgroundBack = () => (dispatch, getState) => {
  dispatch(mobileStep2GuidePrevious());
};

const mobileStep2LogoBack = () => (dispatch, getState) => {
  dispatch(mobileStep2GuidePrevious());
};

const mobileStep2LogoFinished = () => (dispatch, getState) => {
  dispatch(mobileStep2GuideNext());
};

const mobileStep2TextBack = () => (dispatch, getState) => {
  dispatch(mobileStep2GuidePrevious());
};

const mobileStep2TextFinished = () => (dispatch, getState) => {
  dispatch(mobileStep2GuideNext());
};

const mobileStep2ViewPricingBack = () => (dispatch) => {
  dispatch(changeSidebarTabKey(sidebarTabKeyEnum.WhatsNext));
};

const mobileStep2GuidePrevious = () => (dispatch, getState) => {
  const state = getState();
  const allMobileStep2 = getAllowedIcons(state).filter((x) => x !== sidebarTabKeyEnum.Preview);
  const currentSidebarTabKey = getSidebarTabKey(state);
  const currentSidebarTabIndex = allMobileStep2.findIndex((x) => x === currentSidebarTabKey);
  const isGuideMode = getCurrentGuideModeCheck(state);
  const currentImprintAreaKey = getCurrentImprintAreaKey(state);
  const selectedImprintAreaKeys = getSelectedImprintAreaKeys(state);
  const currentImprintAreaKeyIndex = selectedImprintAreaKeys.findIndex((x) => x === currentImprintAreaKey);
  if (isGuideMode && currentImprintAreaKeyIndex === 0 && currentSidebarTabIndex === 0) {
    dispatch(BackwardToImprintOptionSelectAsync());
  } else {
    dispatch(sideBarResetAsync());
  }
};

export const mobileStep2GuideNext = () => (dispatch, getState) => {
  const state = getState();
  const allMobileStep2 = getAllowedIcons(state).filter((x) => x !== sidebarTabKeyEnum.Preview);
  const currentSidebarTabKey = getSidebarTabKey(state);
  const currentSidebarTabIndex = allMobileStep2.findIndex((x) => x === currentSidebarTabKey);
  const isGuideMode = getCurrentGuideModeCheck(state);
  const nextStep2 = currentSidebarTabIndex + 1;
  const selectedImprintAreaKeys = getSelectedImprintAreaKeys(state);
  const currentImprintAreaKey = getCurrentImprintAreaKey(state);
  const canvasIndex = selectedImprintAreaKeys.indexOf(currentImprintAreaKey);

  const currentCanvasTabKey = getCurrentImprintAreaKey(state);
  const selectedImprintAreas = getSelectedImprintAreas(state);
  const currentCanvasTabIndex = getCurrentTabIndex(selectedImprintAreas, currentCanvasTabKey);
  const tabIndex = currentCanvasTabIndex + 1;
  const studioItemType = getStudioItemType(state);
  const needValidateInterval = getNeedValidateInterval(state);

  if (!isGuideMode || nextStep2 === allMobileStep2.length) {
    dispatch(negativeMobileGuideModeAsync());
    dispatch(sideBarResetAsync());
    if (isGuideMode && canvasIndex !== selectedImprintAreaKeys.length - 1) {
      changeTab({
        dispatch,
        tabIndex,
        currentCanvasTabIndex,
        selectedImprintAreas,
        studioItemType,
        currentCanvasTabKey,
        needValidateInterval,
      });
    }
  } else {
    changeSideBarKey({
      newKey:
        nextStep2 > -1 && nextStep2 < allMobileStep2.length ? allMobileStep2[nextStep2] : sidebarTabKeyEnum.WhatsNext,
      dispatch,
      canvasKey: getCurrentImprintAreaKey(state),
      studioItemType: getStudioItemType(state),
      currentSidebarTabKey,
    });
  }
};

export const sideBarResetAsync = () => (dispatch, getState) => {
  let state = getState();
  const allMobileStep2 = getAllowedIcons(state).filter((x) => x !== sidebarTabKeyEnum.Preview);
  const currentSidebarTabKey = getSidebarTabKey(state);
  const currentSidebarTabIndex = allMobileStep2.findIndex((x) => x === currentSidebarTabKey);

  changeSideBarKey({
    newKey: sidebarTabKeyEnum.WhatsNext,
    dispatch,
    canvasKey: getCurrentImprintAreaKey(state),
    studioItemType: getStudioItemType(state),
    currentSidebarTabKey: getSidebarTabKey(state),
  });
  const isGuideMode = getCurrentGuideModeCheck(state);
  if (isGuideMode && (currentSidebarTabIndex === 0 || currentSidebarTabIndex === allMobileStep2.length - 1)) {
    dispatch(negativeMobileGuideModeAsync());
  }
};

export const wantAddImprintOptionClick = () => (dispatch) => {
  dispatch(switchAskIfUserNeedImprintOption(false));
  dispatch(switchShowWarningMessageContainer({ show: false }));
  isMobileOnly && dispatch(setCurrentStep(configuratorStep.canvas));
  dispatch(hideWaitingCover());
};

export const noWantAddImprintOptionClick = () => (dispatch, getState) => {
  const state = getState();
  const currentAskNeedImprintOptionInfo = getCurrentAskNeedImprintOptionInfo(state);
  const selectedImprintAreaKeys = getSelectedImprintAreaKeys(state);
  const currentImprintAreaKey = getCurrentImprintAreaKey(state);
  const canvasIndex = selectedImprintAreaKeys.indexOf(currentImprintAreaKey);
  const lastImprintArea = canvasIndex === selectedImprintAreaKeys.length - 1;
  const hasUpsells = getHasUpsells(state);
  dispatch(
    switchNeedImprintOptionMode({
      imprintAreaKey: currentAskNeedImprintOptionInfo.imprintAreaKey,
      isCheck: false,
    })
  );
  dispatch(showWaitingCover());
  if (lastImprintArea) {
    const currentAskNeedImprintAreaKeyIndex = selectedImprintAreaKeys.indexOf(
      currentAskNeedImprintOptionInfo.imprintAreaKey
    );
    const state = getState();
    let isAddToCartDirectly = true;
    for (let i = currentAskNeedImprintAreaKeyIndex + 1; i <= selectedImprintAreaKeys.length - 1; i++) {
      const needImprintOptionModeCheck = getNeedImprintOptionModeCheck(state, selectedImprintAreaKeys[i]);
      const missingImprintOptionTypeObj = getMissingNonDigitalOptionType(state, selectedImprintAreaKeys[i]);
      if (missingImprintOptionTypeObj.optionText && needImprintOptionModeCheck) {
        isAddToCartDirectly = false;
        break;
      }
    }
    if (isAddToCartDirectly) dispatch(goToUpsellOrAddToCart({ hasUpsells }));
    else dispatch(hideWaitingCover());
  } else dispatch(canvasFinished());
};

export const mainProcess = {
  [configuratorStep.bom]: {
    back: null,
    next: bomFinished,
  },
  [configuratorStep.imprintarea]: {
    back: () => onCancelClick(configuratorStep.bom),
    next: imprintareaFinished,
  },
  [configuratorStep.imprintoption]: {
    back: previousClickHandler,
    next: imprintoptionFinished,
  },
  [configuratorStep.canvas]: {
    back: () => onCancelClick(configuratorStep.imprintoption),
    next: canvasFinished,
  },
  [configuratorStep.template]: {
    back: () => onTemplateCancelClick(configuratorStep.canvas),
    next: templateFinished,
  },
  [configuratorStep.upsell]: {
    back: () => GoogleTagManager(onNoThanksClick(), nextBtnEvent.upsellNoThanksAddtoCart),
    next: upsellFinished,
  },
  [configuratorStep.upsellCustomization]: {
    back: (askIfUserNeedUpsellImprintText, upsellsSelectedItems) =>
      GoogleTagManager(
        onUpsellCustomizationClick(askIfUserNeedUpsellImprintText),
        askIfUserNeedUpsellImprintText ? nextBtnEvent.upsellAddtoCartwithItem : nextBtnEvent.upsellNoThanksAddtoCart,
        askIfUserNeedUpsellImprintText ? { upsellItem: upsellsSelectedItems } : null
      ),
    next: upsellCustomizationFinished,
  },
  [configuratorStep.shipping]: {
    back: null,
    next: updateShippingFinished,
  },
  [configuratorStep.lite]: {
    back: null,
    next: liteFinished,
  },
};

export const step2Process = {
  [sidebarTabKeyEnum.WhatsNext]: {
    back: null,
    next: null,
  },
  [sidebarTabKeyEnum.Background]: {
    back: mobileStep2BackgroundBack,
    next: null,
  },
  [sidebarTabKeyEnum.Logo]: {
    back: mobileStep2LogoBack,
    next: mobileStep2LogoFinished,
  },
  [sidebarTabKeyEnum.Text]: {
    back: mobileStep2TextBack,
    next: mobileStep2TextFinished,
  },
  [sidebarTabKeyEnum.ViewPricing]: {
    back: mobileStep2ViewPricingBack,
    next: null,
  },
};

const switchToStep2 = function () {
  return (dispatch, getState) => {
    const selectedImprintAreaKeys = getSelectedImprintAreaKeys(getState());
    dispatch(
      previewLogics.changePreviewDefaultImprintColor({
        imprintAreaKeys: selectedImprintAreaKeys,
        successCallback: () => {
          dispatch(setCurrentStep(configuratorStep.canvas));
          // update preview data before going to step 2
          dispatch(updatePreviewData());
          // set init canvas scale
          dispatch(resizeWindow());
        },
      })
    );
  };
};

export const updatePreviewData = function () {
  return (dispatch, getState) => {
    const state = getState();
    let selectedImprintAreaKeys = getSelectedImprintAreaKeys(getState());
    const isNextGenUI = getIsNextGenUI(state);
    if (isNextGenUI) {
      selectedImprintAreaKeys = getAllNextGenUIImprintAreaKeys(state);
    }

    dispatch(initMoreviews({ imprintAreaKeys: selectedImprintAreaKeys }));

    const successCallback = function () {
      const fullPreviewDict = getFullPreviewDict(getState());
      dispatch(
        initDefaultUrlIndex({
          imprintAreaKeys: selectedImprintAreaKeys,
          fullPreviewDict,
        })
      );
    };

    if (
      getStudioItemType(getState()) === studioItemTypeEnum.digital ||
      getStudioItemType(getState()) === studioItemTypeEnum.screenPrintedDigital
    ) {
      dispatch(
        previewLogics.updateFullPreview({
          updatePreviewsForAll: true,
          successCallback,
        })
      );
    }
    if (getStudioItemType(getState()) === studioItemTypeEnum.nonDigital) {
      // dispatch(textLogics.checkInitializationTextColor());
      dispatch(
        textLogics.updateNonDigitalFullPreview({
          updatePreviewsForAll: true,
          needUpdatePreview: true,
          successCallback,
        })
      );
    }
  };
};

const initBackgroundDesignPanelShownFlagsAsync = (itemData, imprintFormatsData) => (dispatch) => {
  const { studioItemType } = itemData;
  const isDigital = studioItemType === studioItemTypeEnum.digital;
  isDigital && isMobileOnly && dispatch(initializeBackgroundDesignPanelShownFlags(Object.keys(imprintFormatsData)));
};

const initializeBomOptionsDataHelper = (dispatch, getState, response) => {
  if (response.data.item.inventoryStatus !== 'N') {
    dispatch(initializeVendor(response.data.vendor));
    dispatch(initializeItemSpec(response.data.item));
    dispatch(initializePrice(response.data.price));
    dispatch(initializeCharges(response.data.charges));
    dispatch(initializeChildOptions(response.data.childQuestionOptions));
    dispatch(initializeRelations(response.data.questionRelations));
    dispatch(initializeUniqueOptions(response.data.questionUniqueOptions));
    dispatch(initializeUniqueOptionsBackup(response.data.questionUniqueOptions));
    dispatch(initializeQuestions(response.data.questions));
    dispatch(initializeSizeChart(response.data.sizeChart));
    dispatch(
      updateBomUniqueOptionsForParentChildQuestions(!response.data.preselectedBomOptionsWithNavInkPreconfiguration)
    ); // Note: This action must be dispatched after all BOM store nodes have been initialized!
    dispatch(initializeBomPreview(response.data.bomPreview));
    dispatch(initializeUser(response.data.user));
    const status = getStatus(getState());
    const action = getConfiguratorAction(status);
    if (action === configuratorAction.new && response.data.preselectedBomOptionsOnProductDetailsPage) {
      dispatch(initializeQuantity(response.data.totalQuantity));
      dispatch(setCurrentStep(configuratorStep.imprintarea));
    } else {
      dispatch(setCurrentStep(configuratorStep.bom));
    }
    dispatch(selectDefaultOptionsForBomOptions());
    dispatch(hideWaitingCover());
  } else {
    dispatch(hideWaitingCover());
    dispatch(
      showMessageBox({
        show: true,
        message: 'This item is obsoleted and not sold anymore',
        hasCloseButton: false,
        onOk: () => {
          dispatch(go(-1));
        },
      })
    );
  }
};

const initializeBomOptionsData = (step1Request) => {
  return (dispatch, getState) => {
    const state = getState();
    const isBomOptionsPackageContext = getWhetherCurrentContextIsBomOptionsPackage(state);
    return getBomOptionsData(step1Request)
      .then(function (response) {
        initializeBomOptionsDataHelper(dispatch, getState, response);
        if (isBomOptionsPackageContext) {
          dispatchBomOptionsLoadingCompletedEvent();
        }
      })
      .catch(function (error) {
        dispatch(catchErrorInfo(error));
        dispatch(setCurrentStep(configuratorStep.error));
        dispatch(hideWaitingCover());
        if (isBomOptionsPackageContext) {
          dispatchBomOptionsErrorEvent(error);
        }
      });
  };
};

export const initializeAllForGenProduct = (params) => {
  return (dispatch, getState) => {
    return getAllInitData(params)
      .then(function (response) {
        const state = getState();
        if (response.data.item.inventoryStatus !== 'N') {
          const imprintAreasCount = Object.keys(response.data.imprintFormats).length;

          dispatch(initializeDetailInfo(response.data.itemDetails));
          dispatch(initializeVendor(response.data.vendor));
          dispatch(initializeItemSpec(response.data.item));
          dispatch(initializePrice(response.data.price));
          dispatch(initializeCharges(response.data.charges));
          dispatch(imprintOptionTypeInit(response.data.imprintOptionType));
          dispatch(textLayoutInitAsync(response.data.imprintLocations));
          dispatch(logoLayoutInitAsync(response.data.logoLocations));
          dispatch(
            imprintAreasInitAsync({
              imprintFormats: response.data.imprintFormats,
              imprintGroups: response.data.imprintGroups,
            })
          );
          dispatch(initBackgroundDesignPanelShownFlagsAsync(response.data.item, response.data.imprintFormats));
          dispatch(imprintColorInitAsync(response.data.imprintColor));
          dispatch(initializeActiveCart(response.data.activeCart));
          dispatch(initializeChildOptions(response.data.childQuestionOptions));
          dispatch(initializeRelations(response.data.questionRelations));
          dispatch(initializeUniqueOptions(response.data.questionUniqueOptions));
          dispatch(initSelectCurrentBomOption(response.data.questionUniqueOptions, response.data.questions));
          dispatch(initializeUniqueOptionsBackup(response.data.questionUniqueOptions));
          dispatch(initializeQuestions(response.data.questions));
          dispatch(initializeSizeChart(response.data.sizeChart));

          if (response.data.preselectedBomOptionsWithNavInkPreconfiguration) {
            dispatch(initializeNavInkPreconfigurationParameters(response.data.navInkPreconfigurationParameters));
            dispatch(initializeQuantity(response.data.totalQuantity));
          }

          const status = getStatus(state);
          const action = getConfiguratorAction(status);
          if (action === configuratorAction.new && response.data.preselectedBomOptionsOnProductDetailsPage) {
            dispatch(initializeQuantity(response.data.totalQuantity));
          }
          dispatch(selectDefaultOptionsForBomOptions());

          dispatch(
            updateBomUniqueOptionsForParentChildQuestions(
              !response.data.preselectedBomOptionsOnProductDetailsPage &&
                !response.data.preselectedBomOptionsWithNavInkPreconfiguration
            )
          ); // Note: This action must be dispatched after all BOM store nodes have been initialized!

          dispatch(initializeTrackingPixelScript(response.data.trackingPixelScript));
          dispatch(initializeBomPreview(response.data.bomPreview));
          dispatch(initializeUser(response.data.user));
          //dispatch(initializeUpsells(response.data.upsells));
          dispatch(initializeSpecialSymbols(response.data.specialSymbols));
          dispatch(initializeShipping(response.data.shipping));

          if (imprintAreasCount > 0) {
            //---Start Step2 Data
            dispatch(setImprintGroups(response.data.imprintAreaGroups));

            if (response.data.preselectedBomOptionsOnProductDetailsPage) {
              dispatch(moveToNextFromProductDetailsAsync()); // set currentBomOption
            }

            const newImprintAreaKey = response.data.defaultImprintArea;
            dispatch(nextgenUiSelectImprintArea(newImprintAreaKey));

            let loadedImprintAreaKeys = Object.keys(response.data.imprintFormats);
            // for (let imprintArea of response.data.imprintFormats) {
            //   loadedImprintAreaKeys.push(imprintArea.key);
            // }
            dispatch(changeInitializedImprintAreaKeys(loadedImprintAreaKeys));
            dispatch(initCanvas(response.data.canvas));
            //dispatch(canvas.actions.initBackground(response.data.canvas));
            dispatch(textActions.initFontDict(response.data.font));
            dispatch(textActions.initFontSizeRangeDict(response.data.fontSizeRange));
            dispatch(template.actions.initializeCategoryDict(response.data.category));
            dispatch(template.actions.initializeCommonTemplateDict(response.data.template));
            dispatch(initializeTemplatePreviewDict(response.data.templatePreview));
            dispatch(template.actions.initializeSpecialTemplateDict(response.data.specialTemplate));
            dispatch(addFeatureBackgroundToRecent(response.data.specialTemplate));
            dispatch(
              addInitImageElements({
                studioType: getStudioItemType(getState()),
                imageDict: response.data.image,
                imprintAreaDict: getState().imprintAreaDict,
              })
            );
            dispatch(initializeImprintAreaDimension(response.data.imprintAreaDimension));
            if (
              getStudioItemType(getState()) === studioItemTypeEnum.digital ||
              getStudioItemType(getState()) === studioItemTypeEnum.screenPrintedDigital
            ) {
              dispatch(textLogics.addInitTextElements(response.data.text));
              dispatch(recordTextColor(response.data.text));
            }
            //--Comment it, non-digital products are not in range of M1118
            // if (getStudioItemType(getState()) === studioItemTypeEnum.nonDigital) {
            //   dispatch(textActions.initNonDigitalText(response.data.text));
            //   dispatch(textActions.initNonDigitalTextLine(response.data.textLine));
            //   dispatch(initMandatorySingleUserImage(step2Request.imprintAreas));
            // }

            // nextgen
            //dispatch(changeNextgenUiStatus({ flyoutPanel: { currentPanel: nextGenFlyoutPanelEnum.GetStartedPanel } }));
            changeNextgenUiStatusToGetStarted(dispatch);
            //dispatch(imprintThumbnailInitialize(response.data.imprintThumbnails));
            dispatch(nextGenImprintAreaSelectedAsync());
          }

          const bomOptionsValidation = getBomOptionsValidation(getState());

          dispatch(
            nextgenUiSetting(
              imprintAreasCount,
              response.data.preselectedBomOptionsOnProductDetailsPage && bomOptionsValidation.isValid,
              response.data.preselectedBomOptionsWithNavInkPreconfiguration
            )
          );

          dispatch(hideWaitingCover());
        } else {
          dispatch(hideWaitingCover());
          dispatch(
            showMessageBox({
              show: true,
              message: 'This item is obsoleted and not sold anymore',
              hasCloseButton: false,
              onOk: () => {
                dispatch(go(-1));
              },
            })
          );
        }
      })
      .catch(function (error) {
        dispatch(catchErrorInfo(error));
        dispatch(setCurrentStep(configuratorStep.error));
        dispatch(hideWaitingCover());
      });
  };
};

export const normalizeFontFace = (fontFace) => {
  return fontFace.replace(/\d+/g, '').replace(/\s+/g, ' ').trim();
};

const registerFontFamily = (vendorId, itemId) => {
  return getFontFiles(vendorId, itemId).then((response) => {
    if (response.data) {
      const fontFilesDict = response.data;
      Object.keys(fontFilesDict).forEach((fontCode) => {
        const font = fontFilesDict[fontCode];
        const fontBase64 = font.item2;
        const fontModel = font.item1;
        //registerFont(fontName, fontBase64);
        const style = document.createElement('style');
        const fontWeight = fontModel.hasBold ? 'bold' : 'normal';
        const fontStyle = fontModel.hasItalic ? 'italic' : 'normal';

        const fontFaceToRegister = normalizeFontFace(fontModel.fontFace);
        style.innerText = `
                @font-face {
                  font-family: '${fontFaceToRegister}';
                  src: url('${fontBase64}') format('truetype');
                  font-weight: ${fontWeight};
                  font-style: ${fontStyle};
                }
              `;
        document.head.appendChild(style);
      });
    }
  });
};

export const initializeImprintThumbnails = (vendorId, itemId) => {
  return (dispatch, getState) => {
    return getImprintThumbnails(vendorId, itemId).then((response) => {
      if (response.data) {
        dispatch(imprintThumbnailInitialize(response.data));
      }
    });
  };
};

export const initSelectCurrentBomOption = (allBomOptions, questions) => {
  return (dispatch, getState) => {
    const colorQuestion = questions.find(
      (x) => x.thumbnailType === ThumbnailType.COLOR_SWATCH || x.thumbnailType === ThumbnailType.SCENE7_IMAGE
    );

    if (colorQuestion) {
      const colorCode = colorQuestion.code;

      if (Object.keys(allBomOptions).includes(colorCode)) {
        const colorBomOptions = allBomOptions[colorCode];
        const selectedColorBomOptions = colorBomOptions.filter((f) => f.isSelected);
        if (selectedColorBomOptions && selectedColorBomOptions.length > 0) {
          const currentBomOption = selectedColorBomOptions[0];
          dispatch(setCurrentBomOption(currentBomOption));
        }
      }
    }

    // if (allBomOptions && Object.keys(allBomOptions).length > 0) {
    //   const keys = Object.keys(allBomOptions);
    //   let bomColors = [];
    //   keys.forEach((key) => {
    //     bomColors = bomColors.concat(allBomOptions[key]);
    //   });

    //   const selectedBomOptions = bomColors.filter((f) => f.isSelected);
    //   if (selectedBomOptions && selectedBomOptions.length > 0) {
    //     currentBomOption = selectedBomOptions[0];
    //     dispatch(setCurrentBomOption(currentBomOption));
    //   }
    // }
  };
};

export const nextgenUiSetting = (
  imprintAreasCount,
  preselected,
  isExternalPreselect,
  editItem = '2',
  isInvalid = false
) => {
  return (dispatch, getState) => {
    const state = getState();
    const vendorId = getVendorId(state);
    const status = getStatus(state);
    const action = getConfiguratorAction(status);
    const isInternalBrand = internalBrands.indexOf(vendorId) > -1;

    let stepSettings = {
      nextgenStep: nextgenUiSteps.ProductDetails,
      productDetailMode: nextgenProductDetailModels.Modal,
      steps: {},
    };

    if (action === configuratorAction.virtualProof) {
      if (!isInternalBrand) {
        stepSettings.productDetailMode = nextgenProductDetailModels.OnPage;
      }
      if (preselected) {
        stepSettings.nextgenStep = nextgenUiSteps.Customize;
      } else {
        stepSettings.nextgenStep = nextgenUiSteps.ProductDetails;
      }

      stepSettings.steps[nextgenUiSteps.ProductDetails] = nextgenUiStepButtons.Next;
      stepSettings.steps[nextgenUiSteps.Customize] = nextgenUiStepButtons.VirtualProof;
    } else if (isInternalBrand) {
      const isAdminEditReorder = getIsAdminEditReorder(state);

      if (isAdminEditReorder) {
        stepSettings.nextgenStep = nextgenUiSteps.Customize;
        stepSettings.steps[nextgenUiSteps.Customize] = nextgenUiStepButtons.AddToCart;
      }
      //--- Can customize
      else if (imprintAreasCount > 0) {
        let isDesignLater = false;
        if (action === configuratorAction.new) {
          if (preselected) {
            stepSettings.nextgenStep = nextgenUiSteps.Customize;
          }
        } else if (action === configuratorAction.edit) {
          isDesignLater = getIsAllowDesignLater(state);
          if (isDesignLater) {
            stepSettings.productDetailMode = nextgenProductDetailModels.OnPage;
          }
          //edit customization and bom options are valid
          else if (editItem === '2' && !isInvalid) {
            stepSettings.nextgenStep = nextgenUiSteps.Customize;
          }
        } else if (action === configuratorAction.reorderEdit) {
          if (!isInvalid) {
            stepSettings.nextgenStep = nextgenUiSteps.Customize;
          }
        } else if (action === configuratorAction.designLater && !preselected) {
          isDesignLater = true;
          stepSettings.productDetailMode = nextgenProductDetailModels.OnPage;
        } else {
          //Not a right status, Go to cart directly
          stepSettings.nextgenStep = nextgenUiSteps.GoCart;
        }

        stepSettings.steps[nextgenUiSteps.ProductDetails] = nextgenUiStepButtons.AddToCart;
        if (!isDesignLater) {
          stepSettings.steps[nextgenUiSteps.Customize] = nextgenUiStepButtons.AddToCart;
        }
      } else {
        //---Else, no imprint area, so can't customize, use can only select product detail options
        if (!preselected || action === configuratorAction.edit || action === configuratorAction.reorderEdit) {
          stepSettings.productDetailMode = nextgenProductDetailModels.OnPage;
        } else {
          //Not a right status, Go to cart directly
          stepSettings.productDetailMode = nextgenProductDetailModels.OnPage;
          stepSettings.nextgenStep = nextgenUiSteps.GoCart;
        }

        stepSettings.steps[nextgenUiSteps.ProductDetails] = nextgenUiStepButtons.AddToCart;
      }
    } else {
      stepSettings.productDetailMode = nextgenProductDetailModels.OnPage;
      const isSample = getSample(state);
      if (action === configuratorAction.designLater || imprintAreasCount === 0 || isSample) {
        stepSettings.steps[nextgenUiSteps.ProductDetails] = nextgenUiStepButtons.AddToCart;
      } else {
        if (isExternalPreselect) {
          //TODO: add logic here
        }
        stepSettings.steps[nextgenUiSteps.ProductDetails] = nextgenUiStepButtons.Next;
        stepSettings.steps[nextgenUiSteps.Customize] = nextgenUiStepButtons.AddToCart;
      }
    }

    const showAsModal = stepSettings.productDetailMode === nextgenProductDetailModels.Modal;
    let editingMode = false;
    if (action === configuratorAction.new) {
      editingMode = preselected;
    } else {
      editingMode = !isInvalid;
    }

    dispatch(setProductDetailsInterfaceSettings({ showAsModal, editingMode }));

    dispatch(initNextgenStepSettings(stepSettings));

    if (stepSettings.nextgenStep === nextgenUiSteps.ProductDetails) {
      dispatch(showProductDetailsAsync());
    }
  };
};

export const initializeStep1Data = (step1Request) => {
  return (dispatch, getState) => {
    return getStep1Data(step1Request)
      .then(function (response) {
        const state = getState();
        if (response.data.item.inventoryStatus !== 'N') {
          dispatch(initializeVendor(response.data.vendor));
          dispatch(initializeItemSpec(response.data.item));
          dispatch(initializePrice(response.data.price));
          dispatch(initializeCharges(response.data.charges));
          dispatch(imprintOptionTypeInit(response.data.imprintOptionType));
          dispatch(textLayoutInitAsync(response.data.imprintLocations));
          dispatch(logoLayoutInitAsync(response.data.logoLocations));
          dispatch(
            imprintAreasInitAsync({
              imprintFormats: response.data.imprintFormats,
              imprintGroups: response.data.imprintGroups,
            })
          );
          dispatch(initBackgroundDesignPanelShownFlagsAsync(response.data.item, response.data.imprintFormats));
          dispatch(imprintColorInitAsync(response.data.imprintColor));
          dispatch(initializeActiveCart(response.data.activeCart));
          dispatch(initializeChildOptions(response.data.childQuestionOptions));
          dispatch(initializeRelations(response.data.questionRelations));
          dispatch(initializeUniqueOptions(response.data.questionUniqueOptions));
          dispatch(initializeUniqueOptionsBackup(response.data.questionUniqueOptions));
          dispatch(initializeQuestions(response.data.questions));

          if (response.data.preselectedBomOptionsWithNavInkPreconfiguration) {
            dispatch(initializeNavInkPreconfigurationParameters(response.data.navInkPreconfigurationParameters));
            dispatch(initializeQuantity(response.data.totalQuantity));
          }

          dispatch(initializeSizeChart(response.data.sizeChart));
          dispatch(
            updateBomUniqueOptionsForParentChildQuestions(
              !response.data.preselectedBomOptionsOnProductDetailsPage &&
                !response.data.preselectedBomOptionsWithNavInkPreconfiguration
            )
          ); // Note: This action must be dispatched after all BOM store nodes have been initialized!
          dispatch(initializeTrackingPixelScript(response.data.trackingPixelScript));
          dispatch(initializeBomPreview(response.data.bomPreview));
          dispatch(initializeUser(response.data.user));
          //dispatch(initializeUpsells(response.data.upsells));
          dispatch(initializeSpecialSymbols(response.data.specialSymbols));
          dispatch(initializeShipping(response.data.shipping));

          const status = getStatus(state);
          const action = getConfiguratorAction(status);
          if (action === configuratorAction.new && response.data.preselectedBomOptionsOnProductDetailsPage) {
            dispatch(initializeQuantity(response.data.totalQuantity));
            const bomOptionsValidation = getBomOptionsValidation(getState());
            if (bomOptionsValidation.isValid) {
              dispatch(setCurrentStep(configuratorStep.imprintarea));
              dispatch(bomFinished());
            } else {
              dispatch(setCurrentStep(configuratorStep.bom));
            }
          } else {
            dispatch(setCurrentStep(configuratorStep.bom));
          }

          dispatch(hideWaitingCover());
        } else {
          dispatch(hideWaitingCover());
          dispatch(
            showMessageBox({
              show: true,
              message: 'This item is obsoleted and not sold anymore',
              hasCloseButton: false,
              onOk: () => {
                dispatch(go(-1));
              },
            })
          );
        }
      })
      .catch(function (error) {
        dispatch(catchErrorInfo(error));
        dispatch(setCurrentStep(configuratorStep.error));
        dispatch(hideWaitingCover());
      });
  };
};

export const initializeStep2Data = (step2Request, newImprintAreaKey) => {
  return (dispatch, getState) => {
    return getStep2Data(step2Request)
      .then(function (response) {
        //if (step2Request.imprintAreas.length > 0) {
        dispatch(setCurrentImprintAreaKey(newImprintAreaKey));
        //}
        let loadedImprintAreaKeys = [];
        for (let imprintArea of step2Request.imprintAreas) {
          loadedImprintAreaKeys.push(imprintArea.key);
        }
        dispatch(changeInitializedImprintAreaKeys(loadedImprintAreaKeys));
        dispatch(initCanvas(response.data.canvas));
        //dispatch(canvas.actions.initBackground(response.data.canvas));
        dispatch(textActions.initFontDict(response.data.font));
        dispatch(textActions.initFontSizeRangeDict(response.data.fontSizeRange));
        dispatch(template.actions.initializeCategoryDict(response.data.category));
        dispatch(template.actions.initializeCommonTemplateDict(response.data.template));
        dispatch(initializeTemplatePreviewDict(response.data.templatePreview));
        dispatch(template.actions.initializeSpecialTemplateDict(response.data.specialTemplate));
        dispatch(addFeatureBackgroundToRecent(response.data.specialTemplate));
        dispatch(
          addInitImageElements({
            studioType: getStudioItemType(getState()),
            imageDict: response.data.image,
            imprintAreaDict: getState().imprintAreaDict,
          })
        );
        dispatch(initializeImprintAreaDimension(response.data.imprintAreaDimension));
        if (
          getStudioItemType(getState()) === studioItemTypeEnum.digital ||
          getStudioItemType(getState()) === studioItemTypeEnum.screenPrintedDigital
        ) {
          dispatch(textLogics.addInitTextElements(response.data.text));
          dispatch(recordTextColor(response.data.text));
        }
        if (getStudioItemType(getState()) === studioItemTypeEnum.nonDigital) {
          dispatch(textActions.initNonDigitalText(response.data.text));
          dispatch(textActions.initNonDigitalTextLine(response.data.textLine));
          !isMobileOnly && dispatch(initMandatorySingleUserImage(step2Request.imprintAreas));
        }
        dispatch(switchToStep2());

        dispatch(imprintAreasResetAsync());
        // const history = createBrowserHistory();
        // history.push('/step2');
      })
      .catch(function (error) {
        dispatch(catchErrorInfo(error));
        dispatch(setCurrentStep(configuratorStep.error));
        dispatch(hideWaitingCover());
      });
  };
};

export const initializeCartData = (cartQueryRequest, editItem) => {
  return (dispatch, getState) => {
    return getCartData(cartQueryRequest)
      .then(function (response) {
        let store = getState();
        const returnUrl = getReturnUrl(store);

        const initializeAllFullCartData = () => (dispatch) => {
          dispatch(initializeCartUseScene7Template(response.data.newFxg ? false : true));
          dispatch(initializeVendor(response.data.vendor));
          dispatch(initializeItemSpec(response.data.item));
          dispatch(initializePrice(response.data.price));
          dispatch(initializeCharges(response.data.charges));
          dispatch(imprintOptionTypeInit(response.data.imprintOptionType));
          dispatch(textLayoutInitAsync(response.data.imprintLocations));
          dispatch(logoLayoutInitAsync(response.data.logoLocations));
          dispatch(
            imprintAreasInitAsync({
              imprintFormats: response.data.imprintFormats,
              imprintGroups: response.data.imprintGroups,
            })
          );
          dispatch(initBackgroundDesignPanelShownFlagsAsync(response.data.item, response.data.imprintFormats));
          dispatch(imprintColorInitAsync(response.data.imprintColor));
          dispatch(
            imprintOptionAssembleAsync({
              operation: response.data.operation,
              imprintLocationsDict: response.data.imprintLocations,
              logoLocationsDict: response.data.logoLocations,
              textDict: response.data.text,
              imageDict: response.data.image,
            })
          );
          dispatch(initializeUser(response.data.user));
          dispatch(userImagePrepare());
          dispatch(initializeActiveCart(response.data.activeCart));
          dispatch(initializeChildOptions(response.data.childQuestionOptions));
          dispatch(initializeRelations(response.data.questionRelations));
          dispatch(initializeUniqueOptions(response.data.questionUniqueOptions));
          if (response.data.item.nextGenUI) {
            dispatch(initSelectCurrentBomOption(response.data.questionUniqueOptions, response.data.questions));
            dispatch(initializeDetailInfo(response.data.itemDetails));
          }
          dispatch(initializeUniqueOptionsBackup(response.data.questionUniqueOptions));
          dispatch(initializeQuestions(response.data.questions));
          dispatch(initializeQuantity(response.data.totalQuantity));
          dispatch(initializeSizeChart(response.data.sizeChart));
          dispatch(updateBomUniqueOptionsForParentChildQuestions()); // Note: This action must be dispatched after all BOM store nodes have been initialized!
          dispatch(initializeTrackingPixelScript(response.data.trackingPixelScript));
          dispatch(initializeBomPreview(response.data.bomPreview));
          dispatch(initCanvas(response.data.canvas));
          dispatch(initializeSaveProject(response.data.saveProject));
          dispatch(initBackground(response.data.customBackground));
          dispatch(textActions.initFontDict(response.data.font));
          dispatch(textActions.initFontSizeRangeDict(response.data.fontSizeRange));
          dispatch(template.actions.initializeCategoryDict(response.data.category));
          dispatch(template.actions.initializeCommonTemplateDict(response.data.template));
          dispatch(initializeTemplatePreviewDict(response.data.templatePreview));
          dispatch(template.actions.initializeSpecialTemplateDict(response.data.specialTemplate));
          dispatch(addFeatureBackgroundToRecent(response.data.specialTemplate));
          const studioItemType = getStudioItemType(getState(store));
          dispatch(
            addInitImageElements({
              studioType: studioItemType,
              imageDict: response.data.image,
              imprintAreaDict: getState().imprintAreaDict,
            })
          );
          dispatch(userImageAssembleAsync(response.data.image));
          if (
            studioItemType === studioItemTypeEnum.digital ||
            studioItemType === studioItemTypeEnum.screenPrintedDigital
          ) {
            dispatch(
              textLogics.addInitTextElementsFromCart(
                response.data.text,
                response.data.font,
                response.data.fontSizeRange
              )
            );
            dispatch(recordTextColor(response.data.text));
            if (studioItemType === studioItemTypeEnum.screenPrintedDigital) {
              setLogoEditingStatusToPreview(studioItemType, response.data.image, dispatch);
            }
          }
          if (studioItemType === studioItemTypeEnum.nonDigital) {
            dispatch(textActions.initNonDigitalText(response.data.text));
            dispatch(textActions.initNonDigitalTextLine(response.data.textLine));
            setLogoEditingStatusToPreview(studioItemType, response.data.image, dispatch);
          }
          //dispatch(initializeUpsells(response.data.upsells));
          dispatch(initializeOrder(response.data.order));
          dispatch(initializeSpecialSymbols(response.data.specialSymbols));
          dispatch(initializeShipping(response.data.shipping));
          dispatch(initializeImprintAreaDimension(response.data.imprintAreaDimension));
          let selectedImprintKeys = getAllSelectedImprintAreaKeysFromImprintAreasCombinedDict(
            response.data.imprintGroups
          );

          //Edit no imprint
          if (!selectedImprintKeys || selectedImprintKeys.length === 0) {
            let formats = Object.keys(response.data.imprintFormats);
            if (formats.length > 0) {
              let selectedImprintAreakey = formats[0];
              selectedImprintKeys = [selectedImprintAreakey];
            }
          }

          let loadedImprintAreaKeys = Object.keys(response.data.imprintFormats);
          dispatch(changeInitializedImprintAreaKeys(loadedImprintAreaKeys));

          const isAdminEditReorder = getIsAdminEditReorder(getState());
          if (response.data.item.nextGenUI) {
            dispatch(setImprintGroups(response.data.imprintAreaGroups));
            if (selectedImprintKeys.length > 0) {
              dispatch(nextgenUiSelectImprintArea(selectedImprintKeys[0]));
            }
            dispatch(moveToNextFromProductDetailsAsync());
            //dispatch(imprintThumbnailInitialize(response.data.imprintThumbnails));
            //dispatch(changeNextgenUiStatus({ flyoutPanel: { currentPanel: nextGenFlyoutPanelEnum.GetStartedPanel } }));
            changeNextgenUiStatusToGetStarted(dispatch);

            let imprintAreasCount = Object.keys(response.data.imprintFormats).length;
            const validation = getBomOptionsValidation(getState());

            const isInvalid =
              (response.data.validateResult && response.data.validateResult.isImprintOptionChanged) ||
              !validation.isValid;

            dispatch(
              nextgenUiSetting(
                imprintAreasCount,
                response.data.preselectedBomOptionsOnProductDetailsPage,
                response.data.preselectedBomOptionsWithNavInkPreconfiguration,
                editItem,
                isInvalid
              )
            );

            dispatch(nextGenImprintAreaSelectedAsync());

            if (
              imprintAreasCount === 0 ||
              (response.data.validateResult && response.data.validateResult.isImprintOptionChanged) ||
              editItem !== '2' ||
              !validation.isValid
            ) {
              //dispatch(showProductDetailsAsync());

              if (!validation.isValid) {
                dispatch(
                  showMessageBox({
                    show: true,
                    message: validateResultMessage.bomOptionChanged,
                  })
                );
              }
            }
          } else {
            if (editItem === '2') {
              let imprintAreasCount = Object.keys(response.data.imprintFormats).length;
              const validation = getBomOptionsValidation(getState());
              if (
                imprintAreasCount === 0 ||
                (response.data.validateResult && response.data.validateResult.isImprintOptionChanged)
              ) {
                dispatch(setCurrentStep(configuratorStep.bom));
              } else if (!validation.isValid) {
                dispatch(setCurrentStep(configuratorStep.bom));
                dispatch(
                  showMessageBox({
                    show: true,
                    message: validateResultMessage.bomOptionChanged,
                  })
                );
              } else if (selectedImprintKeys.length > 0) {
                dispatch(setCurrentImprintAreaKey(selectedImprintKeys[0]));
                //dispatch(userImagePrepare());
                studioItemType === studioItemTypeEnum.nonDigital && dispatch(initailizeNeedImprintOptionMode());
                dispatch(switchToStep2());
              } else {
                dispatch(ForwardToImprintOptionSelectAsync());
              }
            } else if (cartQueryRequest.status.toLowerCase() === ACTION_SHIPPING) {
              if (selectedImprintKeys.length > 0) {
                dispatch(setCurrentImprintAreaKey(selectedImprintKeys[0]));
                dispatch(updatePreviewData());
              }
              dispatch(setCurrentStep(configuratorStep.shipping));
            } else if (isAdminEditReorder) {
              //direct to step2 if admin edit digital item from order search
              if (selectedImprintKeys.length > 0) dispatch(gotoStep2());
              else if (response.data.item.isDesignLater) dispatch(ForwardToImprintOptionSelectAsync());
            } else {
              cartQueryRequest.status.toLowerCase() !== ACTION_SHIPPING
                ? dispatch(setCurrentStep(configuratorStep.bom))
                : dispatch(setCurrentStep(configuratorStep.shipping));
            }
          }
        };

        console.log('validate result:');
        console.log(response.data.validateResult);
        dispatch(validateResultForEditing(cartQueryRequest, response, returnUrl, initializeAllFullCartData));
        dispatch(hideWaitingCover());
      })
      .catch((error) => {
        dispatch(catchErrorForInitializeCart(error));
        dispatch(hideWaitingCover());
      });
  };
};

export const initializePreviewWindowsData = (cartQueryRequest, editItem) => {
  return (dispatch, getState) => {
    return getCartData(cartQueryRequest)
      .then(function (response) {
        let store = getState();
        const returnUrl = getReturnUrl(store);

        const initializeAllFullCartData = () => (dispatch) => {
          dispatch(initializeCartUseScene7Template(response.data.newFxg ? false : true));
          dispatch(initializeVendor(response.data.vendor));
          dispatch(initializeItemSpec(response.data.item));
          dispatch(initializePrice(response.data.price));
          dispatch(initializeCharges(response.data.charges));
          dispatch(imprintOptionTypeInit(response.data.imprintOptionType));
          dispatch(textLayoutInitAsync(response.data.imprintLocations));
          dispatch(logoLayoutInitAsync(response.data.logoLocations));
          dispatch(
            imprintAreasInitAsync({
              imprintFormats: response.data.imprintFormats,
              imprintGroups: response.data.imprintGroups,
            })
          );
          dispatch(initBackgroundDesignPanelShownFlagsAsync(response.data.item, response.data.imprintFormats));
          dispatch(imprintColorInitAsync(response.data.imprintColor));
          dispatch(
            imprintOptionAssembleAsync({
              operation: response.data.operation,
              imprintLocationsDict: response.data.imprintLocations,
              logoLocationsDict: response.data.logoLocations,
              textDict: response.data.text,
              imageDict: response.data.image,
            })
          );
          dispatch(initializeUser(response.data.user));
          dispatch(userImagePrepare());
          dispatch(initializeActiveCart(response.data.activeCart));
          dispatch(initializeChildOptions(response.data.childQuestionOptions));
          dispatch(initializeRelations(response.data.questionRelations));
          dispatch(initializeUniqueOptions(response.data.questionUniqueOptions));
          if (response.data.item.nextGenUI) {
            dispatch(initSelectCurrentBomOption(response.data.questionUniqueOptions, response.data.questions));
            dispatch(initializeDetailInfo(response.data.itemDetails));
          }
          dispatch(initializeUniqueOptionsBackup(response.data.questionUniqueOptions));
          dispatch(initializeQuestions(response.data.questions));
          dispatch(initializeQuantity(response.data.totalQuantity));
          dispatch(initializeSizeChart(response.data.sizeChart));
          dispatch(updateBomUniqueOptionsForParentChildQuestions()); // Note: This action must be dispatched after all BOM store nodes have been initialized!
          dispatch(initializeTrackingPixelScript(response.data.trackingPixelScript));
          dispatch(initializeBomPreview(response.data.bomPreview));
          dispatch(initCanvas(response.data.canvas));
          dispatch(initializeSaveProject(response.data.saveProject));
          dispatch(initBackground(response.data.customBackground));
          dispatch(textActions.initFontDict(response.data.font));
          dispatch(textActions.initFontSizeRangeDict(response.data.fontSizeRange));
          dispatch(template.actions.initializeCategoryDict(response.data.category));
          dispatch(template.actions.initializeCommonTemplateDict(response.data.template));
          dispatch(initializeTemplatePreviewDict(response.data.templatePreview));
          dispatch(template.actions.initializeSpecialTemplateDict(response.data.specialTemplate));
          dispatch(addFeatureBackgroundToRecent(response.data.specialTemplate));
          const studioItemType = getStudioItemType(getState(store));
          dispatch(
            addInitImageElements({
              studioType: studioItemType,
              imageDict: response.data.image,
              imprintAreaDict: getState().imprintAreaDict,
            })
          );
          dispatch(userImageAssembleAsync(response.data.image));
          if (
            studioItemType === studioItemTypeEnum.digital ||
            studioItemType === studioItemTypeEnum.screenPrintedDigital
          ) {
            dispatch(
              textLogics.addInitTextElementsFromCart(
                response.data.text,
                response.data.font,
                response.data.fontSizeRange
              )
            );
            dispatch(recordTextColor(response.data.text));
            if (studioItemType === studioItemTypeEnum.screenPrintedDigital) {
              setLogoEditingStatusToPreview(studioItemType, response.data.image, dispatch);
            }
          }
          if (studioItemType === studioItemTypeEnum.nonDigital) {
            dispatch(textActions.initNonDigitalText(response.data.text));
            dispatch(textActions.initNonDigitalTextLine(response.data.textLine));
            setLogoEditingStatusToPreview(studioItemType, response.data.image, dispatch);
          }
          //dispatch(initializeUpsells(response.data.upsells));
          dispatch(initializeOrder(response.data.order));
          dispatch(initializeSpecialSymbols(response.data.specialSymbols));
          dispatch(initializeShipping(response.data.shipping));
          dispatch(initializeImprintAreaDimension(response.data.imprintAreaDimension));
          let selectedImprintKeys = getAllSelectedImprintAreaKeysFromImprintAreasCombinedDict(
            response.data.imprintGroups
          );

          //Edit no imprint
          if (!selectedImprintKeys || selectedImprintKeys.length === 0) {
            let formats = Object.keys(response.data.imprintFormats);
            if (formats.length > 0) {
              let selectedImprintAreakey = formats[0];
              selectedImprintKeys = [selectedImprintAreakey];
            }
          }

          let loadedImprintAreaKeys = Object.keys(response.data.imprintFormats);
          dispatch(changeInitializedImprintAreaKeys(loadedImprintAreaKeys));

          const isAdminEditReorder = getIsAdminEditReorder(getState());
          if (response.data.item.nextGenUI) {
            dispatch(setImprintGroups(response.data.imprintAreaGroups));
            if (selectedImprintKeys.length > 0) {
              dispatch(nextgenUiSelectImprintArea(selectedImprintKeys[0]));
            }

            //dispatch(imprintThumbnailInitialize(response.data.imprintThumbnails));
            //dispatch(changeNextgenUiStatus({ flyoutPanel: { currentPanel: nextGenFlyoutPanelEnum.GetStartedPanel } }));
            changeNextgenUiStatusToGetStarted(dispatch);

            let imprintAreasCount = Object.keys(response.data.imprintFormats).length;
            const validation = getBomOptionsValidation(getState());

            const isInvalid =
              (response.data.validateResult && response.data.validateResult.isImprintOptionChanged) ||
              !validation.isValid;

            dispatch(
              nextgenUiSetting(
                imprintAreasCount,
                response.data.preselectedBomOptionsOnProductDetailsPage,
                response.data.preselectedBomOptionsWithNavInkPreconfiguration,
                editItem,
                isInvalid
              )
            );

            dispatch(nextGenImprintAreaSelectedAsync());

            if (
              imprintAreasCount === 0 ||
              (response.data.validateResult && response.data.validateResult.isImprintOptionChanged) ||
              editItem !== '2' ||
              !validation.isValid
            ) {
              //dispatch(showProductDetailsAsync());

              if (!validation.isValid) {
                dispatch(
                  showMessageBox({
                    show: true,
                    message: validateResultMessage.bomOptionChanged,
                  })
                );
              }
            }
          } else {
            if (editItem === '2') {
              let imprintAreasCount = Object.keys(response.data.imprintFormats).length;
              const validation = getBomOptionsValidation(getState());
              if (
                imprintAreasCount === 0 ||
                (response.data.validateResult && response.data.validateResult.isImprintOptionChanged)
              ) {
                dispatch(setCurrentStep(configuratorStep.bom));
              } else if (!validation.isValid) {
                dispatch(setCurrentStep(configuratorStep.bom));
                dispatch(
                  showMessageBox({
                    show: true,
                    message: validateResultMessage.bomOptionChanged,
                  })
                );
              } else if (selectedImprintKeys.length > 0) {
                dispatch(setCurrentImprintAreaKey(selectedImprintKeys[0]));
                //dispatch(userImagePrepare());
                studioItemType === studioItemTypeEnum.nonDigital && dispatch(initailizeNeedImprintOptionMode());
                dispatch(switchToStep2());
              } else {
                dispatch(ForwardToImprintOptionSelectAsync());
              }
            } else if (cartQueryRequest.status.toLowerCase() === ACTION_SHIPPING) {
              if (selectedImprintKeys.length > 0) {
                dispatch(setCurrentImprintAreaKey(selectedImprintKeys[0]));
                dispatch(updatePreviewData());
              }
              dispatch(setCurrentStep(configuratorStep.shipping));
            } else if (isAdminEditReorder) {
              //direct to step2 if admin edit digital item from order search
              if (selectedImprintKeys.length > 0) dispatch(gotoStep2());
              else if (response.data.item.isDesignLater) dispatch(ForwardToImprintOptionSelectAsync());
            } else {
              cartQueryRequest.status.toLowerCase() !== ACTION_SHIPPING
                ? dispatch(setCurrentStep(configuratorStep.bom))
                : dispatch(setCurrentStep(configuratorStep.shipping));
            }
          }
          dispatch(
            previewLogics.updateFullPreview({
              updatePreviewsForAll: true,
              successCallback: () => dispatch(switchShowPreviewWindow(true)),
            })
          );
        };

        console.log('validate result:');
        console.log(response.data.validateResult);
        dispatch(validateResultForEditing(cartQueryRequest, response, returnUrl, initializeAllFullCartData));
        dispatch(hideWaitingCover());
      })
      .catch((error) => {
        dispatch(catchErrorForInitializeCart(error));
        dispatch(hideWaitingCover());
      });
  };
};

export const validateResultForEditing =
  (cartQueryRequest, response, returnUrl, initializeAllCartData) => (dispatch) => {
    if (
      cartQueryRequest.status.toLowerCase() === ACTION_SHIPPING ||
      cartQueryRequest.status.toLowerCase() === ACTION_EDIT ||
      (cartQueryRequest.status.toLowerCase() === ACTION_REORDEREDIT &&
        response.data.validateResult != null &&
        response.data.validateResult.reorderResultType !== reorderResultType.exact)
    ) {
      if (response.data.validateResult != null) {
        let message = '';
        if (response.data.validateResult.missingArt) {
          message = validateResultMessage.missingArt;
        } else if (response.data.validateResult.isBomOptionChanged) {
          message = validateResultMessage.bomOptionChanged;
        } else if (response.data.validateResult.isImprintOptionChanged) {
          message = validateResultMessage.imprintOptionChanged;
        } else if (response.data.validateResult.invalidQuantityWarning) {
          message = response.data.validateResult.invalidQuantityWarning;
        }
        if (message !== '') {
          dispatch(showMessageBox({ show: true, message: message }));
        }
      }
      dispatch(initializeAllCartData());
    } else {
      let cartIdsValue = '';
      if (response.data.cartIds) {
        let cartIdCount = response.data.cartIds.length;
        for (let i = 0; i < cartIdCount; i++) {
          cartIdsValue += response.data.cartIds[i];
          if (i !== cartIdCount - 1) cartIdsValue += ',';
        }
      }

      window.location.href = `${returnUrl}${
        returnUrl.includes('?') ? '&' : '?'
      }cartIds=${cartIdsValue}&r=${Math.random()}`;
    }
  };

export const catchErrorForInitializeCart = (error) => (dispatch, getState) => {
  exceptionHandling({
    error,
    reject: (internalError) => {
      if (internalError && internalError.code && internalError.code === internalServerExceptionCode.cartItemNotExist) {
        dispatch(
          showMessageBox({
            show: true,
            message: internalServerExceptionMessage[internalServerExceptionCode.cartItemNotExist] || internalError.info,
            hasCloseButton: false,
            onOk: () => {
              dispatch(setBeforeUnloadListen(false));
              let store = getState();
              const isNavinkPlug = getIsNavinkPlug(store);
              if (isNavinkPlug) {
                dispatch(sendBackXml());
              } else {
                window.history.back(-1);
              }
            },
          })
        );
      } else {
        dispatch(catchErrorInfo(error));
        dispatch(hideWaitingCover());
        dispatch(setCurrentStep(configuratorStep.error));
      }
    },
  });
};
const recordTextColor = (textDataDict) => (dispatch, getState) => {
  Object.entries(textDataDict).forEach((entry) => {
    if (entry && entry.length > 1) {
      const formatkey = entry[0];
      const textData = entry[1];
      const color = textData && textData[0] && textData[0].color;
      formatkey && color && dispatch(recordTextColorAsync({ formatkey, color }));
    }
  });
};

const initializeUpsellsText = function (upsells) {
  upsells.forEach((upsell) => {
    let upsellTextDict = {};
    if (upsell.text && upsell.imprintAreas.length > 0 && upsell.text[upsell.imprintAreas[0].key].length > 0) {
      let upsellTextList = [];
      upsell.text[upsell.imprintAreas[0].key].forEach((text, index) => {
        // The first row of data is selected during initialization
        upsellTextList.push({
          data: text,
          ui: {
            guid: uuidv4(),
            status: index === 0 ? elementStatus.SingleSelected : elementStatus.Unselected,
          },
        });
      });
      upsellTextDict[upsell.imprintAreas[0].key] = upsellTextList;
    }
    upsell.text = upsellTextDict;
  });
  return upsells;
};

export const initializeCartUpsellsData = (cartUpsellsRequest) => {
  return (dispatch, getState) => {
    return getCartUpsellsData(cartUpsellsRequest)
      .then((response) => {
        const hasRequiredUpsells = response.data.some((upsell) => upsell && upsell.item && upsell.item.isRequired);
        const hasOptionalUpsells = response.data.some((upsell) => upsell && upsell.item && !upsell.item.isRequired);
        const upsells = initializeUpsellsText(response.data);
        dispatch(initializeUpsells(upsells));
        dispatch(setCurrentStep(configuratorStep.upsell));
        if (hasRequiredUpsells) {
          dispatch(setCurrentUpsellType(UpsellType.required));
        } else if (hasOptionalUpsells) {
          dispatch(setCurrentUpsellType(UpsellType.optional));
        }
        dispatch(hideWaitingCover());
      })
      .catch((error) => {
        dispatch(catchErrorInfo(error));
        dispatch(setCurrentStep(configuratorStep.error));
        dispatch(hideWaitingCover());
      });
  };
};
const getAdminEditorCartRequest = (state) => {
  const adminEditorCartRequest = {
    itemId: getItemId(state),
    vendorId: getVendorId(state),
    refId: getRefId(state),
    text: getTextDataDict(state),
    image: getCanvasImageDataDictForAddCart(state),
    selectedTemplate: getFinalTemplateSelection(state),
    imprintAreas: getSelectedImprintAreas(state),
    imprintLocationCode: getSelectedImprintLocation(state),
    logoLocationCode: getSelectedLogoLocation(state),
  };
  return adminEditorCartRequest;
};
export const addToCart = (config = null) => {
  return (dispatch, getState) => {
    let store = getState();
    const returnUrl = getReturnUrl(store);
    const parameters = getParameters(store);
    const action = getConfiguratorAction(parameters[PARAMETER_STATUS]);
    const saveProjectInfo = getSaveProject(store);
    const isAplInternalBrand = isInternalBrand(store);
    const isAdminEditReorder = getIsAdminEditReorder(store);
    const apiMethod = isAdminEditReorder ? adminEditorAddToCartData : addToCartData;
    const cartRequest = isAdminEditReorder ? getAdminEditorCartRequest(store) : getCartRequest(store, returnUrl);
    const isNextGenUI = (config && config.isNextGenUI) || false;
    const isSaveProject = (config && config.isSaveProject) || false;
    const isPreviewEmail = (config && config.isPreviewEmail) || false;
    const saveToSavedProjects = isSaveProject || (isPreviewEmail && saveProjectInfo.autoSaveFlag);
    cartRequest.isSaveProject = saveToSavedProjects;
    if (saveToSavedProjects) {
      cartRequest.email = isSaveProject ? config.email : saveProjectInfo.email;
      cartRequest.projectName = isSaveProject ? config.projectName : saveProjectInfo.name;
    }

    // Note:
    //   It is necessary to ensure that UpdatePreselectionRequest is only submitted when
    //   customization is completed in Configurator Studio and item is ready to be added
    //   to the shopping cart, rather than when saving project, sending preview email or
    //   performing other actions
    if (!isAdminEditReorder && (isSaveProject || isPreviewEmail) && !!cartRequest.updatePreselectionRequest) {
      cartRequest.updatePreselectionRequest = null;
    } else {
      if (!isSaveProject && !isPreviewEmail) dispatch(showTransparencyCover()); //make sure user cannot interact with UI during add to cart
    }

    let onAddToCartDataSucceeded = function (response) {
      let cartIdCount = response.data.cartIds.length;
      let cartIdsValue = '';
      for (let i = 0; i < cartIdCount; i++) {
        cartIdsValue += response.data.cartIds[i];
        if (i !== cartIdCount - 1) cartIdsValue += ',';
      }
      if (isSaveProject || isPreviewEmail) {
        config.onAddToCart({
          type: responseType.Success,
          email: config.email,
          name: config.projectName,
        });
      } else {
        const isNavinkPlug = getIsNavinkPlug(store);
        const { xml, cartIds } = response.data;
        //returnUrl==UP
        if (isNavinkPlug) {
          respondXmlInNavink(xml);
        } else {
          const returnUrl = getReturnUrl(store);

          if (isAplInternalBrand) {
            if (isAdminEditReorder) {
              const adminToolsHost = getAdminToolsHost(store);
              const order = getOrder(store);
              window.location.href = `${adminToolsHost}/compositionOrderSearch?OrderId=${order.orderId}`;
            } else {
              window.location.href = `${returnUrl}${
                returnUrl.includes('?') ? '&' : '?'
              }cartIds=${cartIdsValue}&r=${Math.random()}`;
            }
          } else {
            //!isAplInternalBrand && !isNavinkPlug (as:returnUrl != UP && !aplInternalBrand)
            postCartXmlWithHiddenForm(returnUrl, xml, cartIds);
          }
        }
      }
    };
    if (isSaveProject) {
      onAddToCartDataSucceeded = GoogleTagManager(onAddToCartDataSucceeded, 'studio_saveproject');
    } else if (action === configuratorAction.edit && isAplInternalBrand) {
      onAddToCartDataSucceeded = GoogleTagManager(onAddToCartDataSucceeded, 'studio_saveandreturntocart');
    } else if (!!config && config.preselectBomOptions) {
      const bomOptionsValidationOff = getBomOptionsValidationOffFlagFromParameters(store);
      const hasNoImprintOptions = getHasNoImprintOptionsFlagFromParameters(store);
      cartRequest.isBomOptionsValidationOffTest = bomOptionsValidationOff;
      cartRequest.placedInCart = hasNoImprintOptions;
      onAddToCartDataSucceeded = config.onSaveBomOptionsSucceeded;
    } else if (!!config && config.saveBomOptionsForDesignLater) {
      cartRequest.status = ACTION_DESIGNLATER;
      onAddToCartDataSucceeded = config.onSaveBomOptionsSucceeded;
    }
    dispatch(setBeforeUnloadListen(false));

    return apiMethod(cartRequest)
      .then(onAddToCartDataSucceeded)
      .then(() => {
        if (isSaveProject) {
          const projectData = getProjectData(store);
          dispatch(
            saveProjectData({
              hasSavedProject: true,
              savedProjectData: projectData,
            })
          );
          if (isNextGenUI) {
            // add new alert.
          } else {
            dispatch(
              showMessageBox({
                show: true,
                message: `Your project has been saved.`,
              })
            );
          }
        }
      })
      .catch(function (error) {
        if (isSaveProject || isPreviewEmail) {
          config.onAddToCart(responseType.Error);
        } else {
          dispatch(setCurrentStep(configuratorStep.error));
          dispatch(hideWaitingCover());
          dispatch(hideTransparencyCover());
        }
      });
  };
};
export const sendBackXml = () => (dispatch, getState) => {
  dispatch(showWaitingCover());
  const store = getState();
  const returnUrl = getReturnUrl(store);
  const cartRequest = {
    refId: getRefId(store),
    coupon: getCoupon(store),
    token: getToken(store),
    priceSvcUrl: getPriceSvcUrl(store),
    displayItemSku: getDisplayItemSku(store),
    isSample: getSample(store),
    itemId: getItemId(store),
    status: getStatus(store),
    zip: getZipCode(store),
    vendorId: getVendorId(store),
    returnUrl,
  };
  return getCartXml(cartRequest)
    .then((response) => {
      const isNavinkPlug = getIsNavinkPlug(store);
      const { xml, cartIds } = response.data;
      //returnUrl==UP
      if (isNavinkPlug) {
        respondXmlInNavink(xml);
      } else {
        const isAplInternalBrand = isInternalBrand(store);
        //!isAplInternalBrand && !isNavinkPlug (as:returnUrl != UP && !aplInternalBrand)
        if (!isAplInternalBrand) {
          postCartXmlWithHiddenForm(returnUrl, xml, cartIds);
        }
      }
      dispatch(hideWaitingCover());
    })
    .catch((_error) => {
      dispatch(setCurrentStep(configuratorStep.error));
      dispatch(hideWaitingCover());
    });
};
export const updateShipping = () => (dispatch, getState) => {
  dispatch(showWaitingCover());
  const store = getState();
  const returnUrl = getReturnUrl(store);
  const cartRequest = {
    refId: getRefId(store),
    coupon: getCoupon(store),
    token: getToken(store),
    priceSvcUrl: getPriceSvcUrl(store),
    displayItemSku: getDisplayItemSku(store),
    isSample: getSample(store),
    itemId: getItemId(store),
    status: getStatus(store),
    zip: getZipCode(store),
    vendorId: getVendorId(store),
    shipping: getShipping(store),
    returnUrl,
  };
  return getCartXml(cartRequest)
    .then((response) => {
      respondXmlInNavink(response.data.xml);
      dispatch(hideWaitingCover());
    })
    .catch((_error) => {
      dispatch(setCurrentStep(configuratorStep.error));
      dispatch(hideWaitingCover());
    });
};

export const ForwardToImprintOptionSelectAsync = () => (dispatch, getState) => {
  // do Imprint Area selected automatically in popup 1a if there is only format combined for each imprint group
  dispatch(imprintAreaSelectedAutomatic());

  let state = getState();
  //there is only format combined for each imprint group
  const hasOnlyOneImprintArea = getHasOnlyOneImprintArea(state);

  const hasOnlyOneCombinationAndNotNoImprint = getHasOnlyOneCombinationAndNotNoImprint(state);

  const currentStudioItemType = getStudioItemType(state);
  if (hasOnlyOneImprintArea || hasOnlyOneCombinationAndNotNoImprint) {
    switch (currentStudioItemType) {
      case studioItemTypeEnum.digital:
      case studioItemTypeEnum.screenPrintedDigital: {
        dispatch(gotoStep2());
        break;
      }
      case studioItemTypeEnum.nonDigital: {
        state = getState();
        const selectedImprintAreaKeys = getTempSelectedImprintAreaKeys(state);
        let nextImprintOptionIndex = 0;
        while (nextImprintOptionIndex < selectedImprintAreaKeys.length) {
          const nextFormatKey = selectedImprintAreaKeys[nextImprintOptionIndex];
          const isMakeSelectionAuto = getMakeSelectionAutoCheck(state, nextFormatKey);
          if (isMakeSelectionAuto) {
            dispatch(recordImprintOptionAutoAsync(nextFormatKey));
            //Imprint Option Selected Automatically
            dispatch(makeSelectionAutoAsync(nextFormatKey));
            nextImprintOptionIndex += 1;
            if (nextImprintOptionIndex === selectedImprintAreaKeys.length) {
              dispatch(gotoStep2());
            }
            continue;
          }
          dispatch(setCurrentImprintAreaKey(nextFormatKey));
          dispatch(setCurrentStep(configuratorStep.imprintoption));
          dispatch(setCurrentImprintOptionStep(imprintOptionStep.Layout));
          dispatch(hideWaitingCover());
          dispatch(whetherAutoSkipImprintOptionPage());
          break;
        }
        break;
      }
    }
  } else {
    dispatch(setCurrentStep(configuratorStep.imprintarea));
    dispatch(hideWaitingCover());
    dispatch(whetherAutoSkipImprintAreaPage());
  }
};

export const BackwardToImprintOptionSelectAsync = () => (dispatch, getState) => {
  let state = getState();
  //there is only format combined for each imprint group
  const hasOnlyOneImprintArea = getHasOnlyOneImprintArea(state);
  const currentStudioItemType = getStudioItemType(state);
  if (hasOnlyOneImprintArea) {
    switch (currentStudioItemType) {
      case studioItemTypeEnum.digital:
      case studioItemTypeEnum.screenPrintedDigital: {
        dispatch(setCurrentStep(configuratorStep.bom));
        break;
      }
      case studioItemTypeEnum.nonDigital: {
        state = getState();
        const selectedImprintAreaKeys = getTempSelectedImprintAreaKeys(state);
        let nextImprintOptionIndex = 0;
        while (nextImprintOptionIndex < selectedImprintAreaKeys.length) {
          const nextFormatKey = selectedImprintAreaKeys[nextImprintOptionIndex];
          const isMakeSelectionAuto = getMakeSelectionAutoCheck(state, nextFormatKey);
          if (isMakeSelectionAuto) {
            nextImprintOptionIndex += 1;
            if (nextImprintOptionIndex === selectedImprintAreaKeys.length) {
              dispatch(setCurrentStep(configuratorStep.bom));
            }
            continue;
          }
          dispatch(setCurrentImprintAreaKey(nextFormatKey));
          dispatch(setCurrentStep(configuratorStep.imprintoption));
          dispatch(setCurrentImprintOptionStep(imprintOptionStep.Layout));
          break;
        }
        break;
      }
    }
  } else {
    dispatch(setCurrentStep(configuratorStep.imprintarea));
  }
};

export const gotoStep2 = () => {
  return (dispatch, getState) => {
    let store = getState();
    const studioItemType = getStudioItemType(store);
    const isNonDigital = studioItemType === studioItemTypeEnum.nonDigital;
    isMobileOnly && isNonDigital && dispatch(mobileGuideModeSetupAsync());
    isNonDigital && dispatch(initailizeNeedImprintOptionMode());
    const selectedImprintKeys = getSelectedImprintAreaKeys(store);
    //dispatch(userImagePrepare());
    let step2Request = getStep2Request(store);
    if (step2Request.imprintAreas.length > 0) {
      dispatch(initializeStep2Data(step2Request, selectedImprintKeys[0]));
    } else {
      dispatch(setCurrentImprintAreaKey(selectedImprintKeys[0]));
      dispatch(switchToStep2());
    }
  };
};

const validateImprintRequired = () => (dispatch, getState) => {
  const state = getState();
  const returnUrl = getReturnUrl(state);
  let cartRequest = getCartRequest(state, returnUrl);
  const uiType = getPromoStudioUITypeSelector(state);
  const optionalText = getOpitonalText(state);
  //imprint required
  let isImprintRequired = getIsImprintRequired(state);
  if (isImprintRequired) {
    let showImprintRequiredWarning = true;
    let selectedImprintAreaKeys = getSelectedImprintAreaKeys(state);
    let studioItemType = getStudioItemType(state);
    if (selectedImprintAreaKeys.length > 0) {
      for (let imprintAreaKey of selectedImprintAreaKeys) {
        const currentOptionType = getImprintOptionType(state, imprintAreaKey);
        let selectedTemplate = cartRequest.selectedTemplate[imprintAreaKey];
        let hasTemplate =
          studioItemType === studioItemTypeEnum.digital &&
          selectedTemplate.templateType !== template.TemplateType.BLANK;
        let textDataList = getImprintedTextDataDict(state)[imprintAreaKey];
        let hasImprintText = textDataList !== undefined && textDataList.length > 0;
        let imageDataList = cartRequest.image[imprintAreaKey];
        let hasImage = imageDataList !== undefined && imageDataList.length > 0;
        showImprintRequiredWarning = !(
          (hasTemplate && studioItemType === studioItemTypeEnum.digital) ||
          hasImprintText ||
          (uiType === promoStudioUITypeValue.LiteUI &&
            optionalText &&
            (currentOptionType === imprintOptionType.TextOnly || currentOptionType === imprintOptionType.TextLogo)) ||
          hasImage
        );
        if (!showImprintRequiredWarning) break;
      }
    }
    if (showImprintRequiredWarning) {
      const isNextGenUI = getIsNextGenUI(state);
      if (isNextGenUI) {
        dispatch(
          showMessageBox({
            show: true,
            message: 'Please customize the item with an imprint to continue.',
            onOk: () => {
              const currentImprintAreaKey = getCurrentImprintAreaKey(state);
              dispatch(nextgenUiSelectImprintArea(currentImprintAreaKey, false));
            },
          })
        );
      } else {
        dispatch(showWarningMessageContainer(['Please customize the item with an imprint to continue.']));
      }

      dispatch(hideWaitingCover());
      return false;
    } else {
      return true;
    }
  } else {
    return true;
  }
};

const confirmDialogAsync = (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(
      showConfirmDialog({
        show: true,
        title: 'Are you sure you want to keep this product blank?',
        message: '',
        okText: 'Yes, Keep Product Blank',
        cancelText: 'No, Keep Editing Product(s)',
        onOk: () => {
          resolve(true);
        },
        onCancel: () => {
          resolve(false);
        },
      })
    );
  });
};

export const saveBlankProjectConfirmAsync = (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(
      showConfirmDialog({
        show: true,
        title: 'Are you sure you want to save a blank product?',
        message: '',
        okText: 'Yes, Keep Product Blank',
        cancelText: 'No, Keep Editing Product(s)',
        onOk: () => {
          resolve(true);
        },
        onCancel: () => {
          resolve(false);
        },
      })
    );
  });
};

export const nextgenValidateImprintRequired = () => (dispatch, getState) => {
  const state = getState();
  const isImprintRequired = getIsImprintRequired(state);
  const appliedImprintKeys = getAllAppliedImprintAreaKeys(state);

  let result = validateImprintRequiredResult.Valid;
  if (!isImprintRequired) {
    if (!appliedImprintKeys || appliedImprintKeys.length === 0) {
      result = validateImprintRequiredResult.Confirm;
    }
  } else {
    const combinationDict = state.imprintAreasCombinedDict;
    const groupKeys = Object.keys(combinationDict);

    if (!appliedImprintKeys || appliedImprintKeys.length === 0) {
      const currentImprintAreaKey = getCurrentImprintAreaKey(state);
      dispatch(nextgenUiSelectImprintArea(currentImprintAreaKey, false));
      return groupKeys.length > 1 ? validateImprintRequiredResult.GroupError : validateImprintRequiredResult.ItemError;
    }

    const groupImprintAreas = getAllGroupImprintAreas(state);
    groupKeys.forEach((group) => {
      const imprintCombination = combinationDict[group];
      const hasNoImprint = imprintCombination.combinations.some((i) => i.combinationsText === 'No Imprint');
      const imprintAreas = groupImprintAreas[group];
      if (!hasNoImprint) {
        const groupAppliedKeys = appliedImprintKeys.filter((f) => imprintAreas.indexOf(f) > -1);
        if (groupAppliedKeys.length === 0) {
          result = validateImprintRequiredResult.GroupError;
          dispatch(nextgenUiSelectImprintArea(imprintAreas[0]));
          return;
        }
      }
    });
  }

  return result;
};

export const nextgenUiGoToUpsellOrAddToCart = () => {
  return (dispatch, getState) => {
    let state = getState();

    const allowDesignLater = getIsAllowDesignLater(state);

    var hasFormat = state.imprintAreaDict ? Object.keys(state.imprintAreaDict).length > 0 : false;

    if (CheckTempArt(dispatch, state)) return;

    if (allowDesignLater || !hasFormat) {
      dispatch(goToUpsellOrAddToCartAfterValidation());
    } else {
      const validateResult = dispatch(nextgenValidateImprintRequired());

      state = getState();
      if (
        validateResult === validateImprintRequiredResult.GroupError ||
        validateResult === validateImprintRequiredResult.ItemError
      ) {
        const messageText = `Please add text or art before continuing to the cart. An imprint is required for ${
          validateResult === validateImprintRequiredResult.GroupError ? 'any surface of each group' : 'this item'
        }.`;
        dispatch(
          showMessageBox({
            show: true,
            message: messageText,
            title: 'Imprint is Required',
            onClose: () => {},
            onOk: () => {},
          })
        );
        dispatch(hideWaitingCover());
        return;
      } else if (validateResult === validateImprintRequiredResult.Confirm) {
        dispatch(hideWaitingCover());
        // Confirm Dialog for NO Imprint
        confirmDialogAsync(dispatch).then((res) => {
          const returnValue = res;
          if (!returnValue) {
            // -- Select "Keep Editing Product"
            const currentImprintAreaKey = getCurrentImprintAreaKey(state);
            dispatch(nextgenUiSelectImprintArea(currentImprintAreaKey, false));
            dispatch(hideWaitingCover());
            return;
          } // -- Select "Keep Product Blank"
          else if (dispatch(validateAllImprintAreaCanvasData()) && dispatch(validateImageDpi())) {
            dispatch(goToUpsellOrAddToCartAfterValidation());
            dispatch(showWaitingCover());
          }
        });
      } else if (validateResult === validateImprintRequiredResult.Valid) {
        if (dispatch(validateAllImprintAreaCanvasData()) && dispatch(validateImageDpi())) {
          //if special image is allowed, but user didn't add it, show popup tips
          dispatch(
            checkNoAddSpecialImage({
              onOk: () => {
                dispatch(goToUpsellOrAddToCartAfterValidation());
                dispatch(showWaitingCover());
              },
            })
          );
        }
      }
    }
  };
};

export const validateCurrentImprintAreaInternalInvalid = () => (dispatch, getState) => {
  const state = getState();

  const currentStudioItemType = getStudioItemType(state);
  const needValidateInterval = getNeedValidateInterval(state);

  if (
    currentStudioItemType === studioItemType.screenPrintedDigital &&
    needValidateInterval &&
    dispatch(isIntervalInvalid())
  ) {
    //dispatch(showWarningMessageContainer([CANVAS_IMPRINT_TOO_CLOSE]));
    dispatch(
      showMessageBox({
        show: true,
        message: CANVAS_IMPRINT_TOO_CLOSE,
      })
    );

    return false;
  }

  return true;
};

export const goToUpsellOrAddToCartAfterValidation = () => {
  return (dispatch, getState) => {
    const state = getState();
    const hasUpsells = getHasUpsells(state);
    const status = getStatus(state);
    if (hasUpsells) {
      let ifEdit = getConfiguratorAction(status) === configuratorAction.edit;
      if (ifEdit) dispatch(addToCart());
      else dispatch(initializeUpsellData());
    } else {
      dispatch(addToCart());
    }
  };
};

export const goToUpsellOrAddToCart = (props = {}) => {
  return (dispatch, getState) => {
    const { hasUpsells, addToCartDirectly, allowDesignLater } = props;
    const state = getState();
    const imprintAreaKey = getCurrentImprintAreaKey(state);
    const currentImprintOptionType = getImprintOptionType(state, imprintAreaKey);
    const status = getStatus(state);
    const currentStudioItemType = getStudioItemType(state);
    const needValidateInterval = getNeedValidateInterval(state);

    if (CheckTempArt(dispatch, state)) return;

    if (
      allowDesignLater ||
      (dispatch(validateImprintRequired()) &&
        dispatch(validateAllImprintAreaCanvasData()) &&
        dispatch(validateImageDpi()))
    ) {
      if (hasUpsells) {
        let ifEdit = getConfiguratorAction(status) === configuratorAction.edit;
        if (addToCartDirectly || currentImprintOptionType === imprintOptionType.LogoOnly) {
          if (ifEdit) dispatch(addToCart());
          else dispatch(initializeUpsellData());
        } else if (
          currentImprintOptionType === imprintOptionType.TextOnly ||
          currentImprintOptionType === imprintOptionType.TextLogo
        ) {
          const errorCallback = function () {
            dispatch(hideWaitingCover());
          };
          const successCallback = function () {
            if (ifEdit) dispatch(addToCart());
            else dispatch(initializeUpsellData());
          };
          dispatch(textLogics.invalidCharactersRetrieval());
          dispatch(
            textLogics.updateNonDigitalFullPreview({
              successCallback,
              errorCallback,
            })
          );
        }
      } else {
        if (addToCartDirectly) {
          dispatch(addToCart());
        } else {
          if (
            currentStudioItemType === studioItemTypeEnum.digital ||
            currentStudioItemType === studioItemTypeEnum.screenPrintedDigital
          ) {
            if (
              currentStudioItemType === studioItemType.screenPrintedDigital &&
              needValidateInterval &&
              dispatch(isIntervalInvalid())
            ) {
              dispatch(showWarningMessageContainer([CANVAS_IMPRINT_TOO_CLOSE]));
              dispatch(hideWaitingCover());
            } else {
              dispatch(addToCart());
            }
          } else if (currentStudioItemType === studioItemTypeEnum.nonDigital) {
            if (currentImprintOptionType === imprintOptionType.LogoOnly) {
              dispatch(addToCart());
            } else if (
              currentImprintOptionType === imprintOptionType.TextOnly ||
              currentImprintOptionType === imprintOptionType.TextLogo
            ) {
              const errorCallback = function () {
                dispatch(hideWaitingCover());
              };
              const successCallback = function () {
                dispatch(addToCart());
              };
              dispatch(textLogics.invalidCharactersRetrieval());
              dispatch(
                textLogics.updateNonDigitalFullPreview({
                  successCallback,
                  errorCallback,
                })
              );
            }
          }
        }
      }
    }
  };
};

const CheckTempArt = (dispatch, state) => {
  const tempElement = getTempElement(state);
  const tempBackgroundImage = getTempBackgroundImage(state);
  let tempElementData = tempElement ? tempElement.data : null;
  tempElementData =
    tempElementData || (tempBackgroundImage && tempBackgroundImage.data ? tempBackgroundImage.data : null);

  if (tempElementData) {
    dispatch(
      applyNoticeToggle({
        show: true,
        keepPromptText: tempElementData.type === userImageType.UploadLogo || tempElementData.type === undefined,
      })
    );
    dispatch(hideWaitingCover());
    return true;
  }

  return false;
};

const addToCartLite = () => {
  return (dispatch, getState) => {
    const state = getState();
    const currentStudioItemType = getStudioItemType(state);
    const isTecSysItem = getTecSysItemFlag(state);
    const hasText = hasTextImprintOptionType(state);
    if (
      (isTecSysItem ||
        Object.keys(state.imprintAreaDict).length === 0 ||
        (dispatch(validateLiteImprintAreaSelected()) && dispatch(validateImprintRequired()))) &&
      dispatch(validateAllImprintAreaCanvasData())
    ) {
      if (currentStudioItemType === studioItemTypeEnum.nonDigital) {
        if (hasText) {
          const successCallback = function () {
            dispatch(addToCart());
          };
          dispatch(textLogics.invalidCharactersRetrieval({ fromLiteText: true }));
          dispatch(textLogics.updateNonDigitalFullPreview({ successCallback }));
        } else {
          dispatch(addToCart());
        }
      }
    }
  };
};

const respondXmlInNavink = (xml) => {
  console.log('respondXmlInNavink', xml);
  postXmlLogic && postXmlLogic(xml);
};
const postCartXmlWithHiddenForm = (returnUrl, xml, cartIds) => {
  const cgiForm = document.createElement('form');
  cgiForm.method = 'POST';
  //cgiForm.target = '_blank';
  cgiForm.action = returnUrl;
  cgiForm.id = 'cgiForm-xml-post';
  cgiForm.name = 'cgiForm-xml-post';
  document.body.appendChild(cgiForm);
  const xmlInp = document.createElement('input');
  xmlInp.type = 'hidden';
  xmlInp.name = 'xml';
  xmlInp.value = xml;
  cgiForm.appendChild(xmlInp);
  const cartIdsInp = document.createElement('input');
  cartIdsInp.type = 'hidden';
  cartIdsInp.name = 'cartIds';
  cartIdsInp.value = cartIds;
  cgiForm.appendChild(cartIdsInp);
  cgiForm.submit();
  document.body.removeChild(cgiForm);
};

export const initializeUpsellData = () => {
  return (dispatch, getState) => {
    const state = getState();
    const itemId = getItemId(state);
    const vendorId = getVendorId(state);
    const priceSvcUrl = getPriceSvcUrl(state);
    const token = getToken(state);
    const coupon = getCoupon(state);
    const displayItemSku = getDisplayItemSku(state);
    const isSample = getSample(state);
    const companyName = getUserCompanyName(state);
    const questions = getAllQuestions(state);
    const uniqueOptions = getAllUniqueOptions(state);
    const uspellRequest = {
      vendorId: vendorId,
      itemId: itemId,
      priceSvcUrl: priceSvcUrl,
      token: token,
      coupon: coupon,
      displayItemSku: displayItemSku,
      isSample: isSample,
      companyName: companyName,
      questionList: questions,
      questionUniqueOptionDictionary: uniqueOptions,
    };
    return getUpsellData(uspellRequest).then(function (response) {
      // Note:
      //  We need to check if the returned upsell list is empty or not here.
      //  In some special cases, such as an upsell item has no pricing set up,
      //  or gets pricing failed, the upsell item will be removed from the final list.
      //  If the returned upsell list is empty, we should call 'addToCart()' directly.
      if (response.data.length === 0) {
        dispatch(addToCart());
        return;
      }

      const hasRequiredUpsells = response.data.some((upsell) => upsell && upsell.item && upsell.item.isRequired);
      const hasOptionalUpsells = response.data.some((upsell) => upsell && upsell.item && !upsell.item.isRequired);
      const upsells = initializeUpsellsText(response.data);
      dispatch(initializeUpsells(upsells));
      dispatch(setCurrentStep(configuratorStep.upsell));
      if (hasRequiredUpsells) {
        dispatch(setCurrentUpsellType(UpsellType.required));
      } else if (hasOptionalUpsells) {
        dispatch(setCurrentUpsellType(UpsellType.optional));
      }
      dispatch(hideWaitingCover());
    });
  };
};

function getBomRequest(store) {
  const itemId = getIsLiteParentChildItem(store) ? getChildItemIdFromBomSelectionForLite(store) : getItemId(store);
  const vendorId = getVendorId(store);
  const priceSvcUrl = getPriceSvcUrl(store);
  const token = getToken(store);
  const coupon = getCoupon(store);
  const displayItemSku = getDisplayItemSku(store);
  const isSample = getSample(store);
  const selectedBom = getFinalBomOptionsSelection(store);
  let bomOption = {
    bomOptions: selectedBom.generalOptions,
    pseudoParentChildQuestionOptionDictionaryList: selectedBom.pseudoParentChildQuestionOptionDictionaries,
    quantity: selectedBom.quantity,
  };
  const step2Request = {
    vendorId: vendorId,
    itemId: itemId,
    priceSvcUrl: priceSvcUrl,
    token: token,
    coupon: coupon,
    displayItemSku: displayItemSku,
    isSample: isSample,
    bomOption,
  };
  return step2Request;
}

function getStep2Request(store) {
  let bomRequest = getBomRequest(store);
  let step2Request = {};
  Object.assign(step2Request, bomRequest);
  const uninitializedImprintAreas = getUninitializedImprintAreas(store);
  const uninitializedImprintLocation = getUninitializedImprintLocation(store);
  const uninitializedLogoLocation = getUninitializedLogoLocation(store);
  step2Request.imprintAreas = uninitializedImprintAreas;
  step2Request.imprintLocationCode = uninitializedImprintLocation;
  step2Request.logoLocationCode = uninitializedLogoLocation;
  step2Request.templateId = getTemplateId(store);
  const imprintOption = getAllImprintOptionUI(store);
  const imprintOptionKeys = Object.keys(imprintOption);
  let textColorDict = {};
  for (let imprintOptionKey of imprintOptionKeys) {
    textColorDict[imprintOptionKey] = imprintOption[imprintOptionKey].textColor;
  }
  step2Request.imprintColor = textColorDict;
  step2Request.companyName = getUserCompanyName(store);
  return step2Request;
}

export function getCartRequest(store, returnUrl) {
  const refId = getRefId(store);
  const textDataDict = getTextDataDict(store);
  const imageDataDict = getCanvasImageDataDictForAddCart(store);
  const status = getStatus(store);
  const selectedUpsells = getSelectedUpsells(store);
  const selectedTemplate = getFinalTemplateSelection(store);
  const uiType = getPromoStudioUITypeSelector(store);
  const stockImageBomOptions =
    uiType === promoStudioUITypeValue.LiteUI
      ? getLiteSelectedColorBomOptions(store)
      : getSelectedColorBomOptions(store);
  let bomRequest = getBomRequest(store);
  let cartRequest = {};
  Object.assign(cartRequest, bomRequest);
  const selectedImprintAreas = getSelectedImprintAreas(store);
  const selectedImprintLocation = getSelectedImprintLocation(store);
  const selectedLogoLocation = getSelectedLogoLocation(store);
  cartRequest.imprintAreas = selectedImprintAreas;
  cartRequest.imprintLocationCode = selectedImprintLocation;
  cartRequest.logoLocationCode = selectedLogoLocation;
  cartRequest.text = textDataDict;
  cartRequest.image = imageDataDict;
  cartRequest.selectedTemplate = selectedTemplate;
  cartRequest.refId = refId;
  cartRequest.status = status;
  cartRequest.upsellItems = selectedUpsells;
  cartRequest.returnUrl = returnUrl;
  cartRequest.zip = getZipCode(store);
  cartRequest.order = getOrder(store);
  cartRequest.shipping = getShipping(store);
  cartRequest.scale = getScaleDict(store);
  cartRequest.stockImageBomOptions = stockImageBomOptions;
  cartRequest.deviceValue = isMobileOnly ? deviceValue.Mobile : deviceValue.Desktop;
  cartRequest.updatePreselectionRequest = getUpdatePreselectionRequest(store);
  return cartRequest;
}

export const getNextButtonType = (nextButtonDisplayConditions) => {
  const {
    currentStep,
    isImprintAreaNoneSelected,
    lastImprintArea,
    isSample,
    isAdminEditReorder,
    imprintAreas,
    hasCustomizableUpsellsSelected,
    lastUpsell,
    isAllNoImprintChosen,
    hideAddToCartButton,
    allowDesignLater,
    askIfUserNeedUpsellImprintText,
    action,
    askIfUserNeedImprintOption,
    currentAskNeedImprintOptionInfo,
    isVirtualProof,
  } = nextButtonDisplayConditions;
  let nextButtonType = processButtonType.next;
  switch (currentStep) {
    case configuratorStep.bom:
      if (isSample) nextButtonType = getNextTextFinalization(isAdminEditReorder);
      else if (Object.keys(imprintAreas).length === 0) {
        if (hideAddToCartButton) {
          nextButtonType = processButtonType.none;
        } else {
          nextButtonType = getNextTextFinalization(isAdminEditReorder);
        }
      } else if (allowDesignLater) {
        if (hideAddToCartButton) {
          nextButtonType = processButtonType.none;
        } else {
          nextButtonType = processButtonType.addToCart;
        }
      } else nextButtonType = processButtonType.next;
      break;
    case configuratorStep.imprintarea:
      if (isImprintAreaNoneSelected) {
        if (hideAddToCartButton) {
          nextButtonType = processButtonType.none;
        } else {
          nextButtonType = getNextTextFinalization(isAdminEditReorder);
        }
      } else nextButtonType = isMobileOnly ? processButtonType.continue : processButtonType.next;
      break;
    case configuratorStep.imprintoption:
      if (isAllNoImprintChosen) {
        if (hideAddToCartButton) {
          nextButtonType = processButtonType.none;
        } else {
          nextButtonType = getNextTextFinalization(isAdminEditReorder);
        }
      } else nextButtonType = isMobileOnly ? processButtonType.continue : processButtonType.next;
      break;
    case configuratorStep.canvas:
      if (!isMobileOnly && hideAddToCartButton) {
        nextButtonType = processButtonType.none;
      } else if (isVirtualProof) nextButtonType = processButtonType.emailVirtualProof;
      else if (askIfUserNeedImprintOption && currentAskNeedImprintOptionInfo.optionText)
        nextButtonType = getMissingImprintOptionButtonType(currentAskNeedImprintOptionInfo, true);
      else if (!lastImprintArea) nextButtonType = processButtonType.next;
      else nextButtonType = getNextTextFinalization(isAdminEditReorder);
      break;
    case configuratorStep.template:
      nextButtonType = processButtonType.applyBackground;
      break;
    case configuratorStep.upsell:
      nextButtonType = hasCustomizableUpsellsSelected
        ? processButtonType.personalizeAndAddToCart
        : getNextTextFinalization(isAdminEditReorder);
      break;
    case configuratorStep.upsellCustomization:
      if ((!isMobileOnly || action === configuratorAction.editCartUpsells) && askIfUserNeedUpsellImprintText) {
        nextButtonType = processButtonType.wantAddText;
      } else {
        if (lastUpsell) {
          nextButtonType = processButtonType.addToCart;
        } else {
          nextButtonType = processButtonType.personalizeAndAddToCart;
        }
      }
      break;
    case configuratorStep.shipping:
      nextButtonType = processButtonType.addToCart;
      break;
    case configuratorStep.lite:
      nextButtonType = processButtonType.addToCart;
      break;
    default:
      nextButtonType = processButtonType.next;
      break;
  }
  return nextButtonType;
};

export const getNextButtonId = (props) => (dispatch, getState) => {
  const { nextButtonType, btnText } = props;
  const state = getState();
  const currentStep = getCurrentStep(state);
  const allowDesignLater = getIsAllowDesignLater(state);
  let btnId = btnText.replaceAll(' ', '_');
  switch (currentStep) {
    case configuratorStep.bom:
      btnId =
        nextButtonType === processButtonType.addToCart
          ? allowDesignLater
            ? nextBtnId.designServiceAddToCart
            : nextBtnId.productOptionsAddtoCart
          : nextBtnId.productOptionsNext;

      break;
    case configuratorStep.imprintarea:
    case configuratorStep.imprintoption:
      btnId =
        nextButtonType === processButtonType.addToCart ? nextBtnId.noImprintAddtoCart : nextBtnId.imprintOptionsNext;
      break;
    case configuratorStep.canvas:
      btnId =
        nextButtonType === processButtonType.emailVirtualProof
          ? nextBtnId.emailVirtualProof
          : nextButtonType === processButtonType.addToCart
          ? nextBtnId.addToCart
          : nextBtnId.next;
      break;
    case configuratorStep.upsell:
    case configuratorStep.upsellCustomization:
      btnId =
        nextButtonType === processButtonType.addToCart
          ? nextBtnId.upsellAddtoCart
          : nextButtonType === processButtonType.noThanks
          ? nextBtnId.upsellNoThanksAddtoCart
          : nextBtnId.next;
      break;
    default:
      btnId = btnText.replaceAll(' ', '_');
      break;
  }
  return btnId;
};

export const getMobileBackButtonType = (currentStep, upsellType) => {
  let backButtonType = '';
  switch (currentStep) {
    case configuratorStep.bom:
    case configuratorStep.shipping:
    case configuratorStep.lite:
      backButtonType = processButtonType.none;
      break;
    case configuratorStep.upsell:
      backButtonType = upsellType === UpsellType.optional ? processButtonType.noThanks : processButtonType.none;
      break;
    case configuratorStep.upsellCustomization:
      backButtonType = upsellType === UpsellType.optional ? processButtonType.noThanks : processButtonType.none;

      break;
    default:
      backButtonType = processButtonType.cancel;
      break;
  }
  return backButtonType;
};

export const getMissingImprintOptionButtonType = (currentAskNeedImprintOptionInfo, isWantAddOption) => {
  if (currentAskNeedImprintOptionInfo.optionText) {
    let missingImprintOptionButtonType = '';
    switch (currentAskNeedImprintOptionInfo.optionText) {
      case imprintOptionText.TextOnly:
        missingImprintOptionButtonType = isWantAddOption
          ? processButtonType.wantAddImprintText
          : processButtonType.noWantAddImprintText;
        break;
      case imprintOptionText.LogoOnly:
        missingImprintOptionButtonType = isWantAddOption
          ? processButtonType.wantAddImprintLogo
          : processButtonType.noWantAddImprintLogo;
        break;
      case imprintOptionText.TextLogo:
        missingImprintOptionButtonType = isWantAddOption
          ? processButtonType.wantAddImprintTextLogo
          : processButtonType.noWantAddImprintTextLogo;
        break;
      case imprintOptionText.Slogan:
        missingImprintOptionButtonType = isWantAddOption
          ? processButtonType.wantAddImprintSlogan
          : processButtonType.noWantAddImprintSlogan;
        break;

      default:
        break;
    }
    return missingImprintOptionButtonType;
  }
};
export const getDesktopBackButtonType = (
  currentStep,
  upsellType,
  askIfUserNeedUpsellImprintText,
  askIfUserNeedImprintOption,
  currentAskNeedImprintOptionInfo
) => {
  let backButtonType = '';
  switch (currentStep) {
    case configuratorStep.template:
      backButtonType = processButtonType.cancel;
      break;
    case configuratorStep.imprintoption:
      backButtonType = processButtonType.previous;
      break;
    case configuratorStep.canvas:
      if (askIfUserNeedImprintOption && currentAskNeedImprintOptionInfo.optionText)
        backButtonType = getMissingImprintOptionButtonType(currentAskNeedImprintOptionInfo, false);
      else backButtonType = processButtonType.none;
      break;
    case configuratorStep.upsell:
      backButtonType =
        upsellType === UpsellType.optional
          ? !askIfUserNeedUpsellImprintText
            ? processButtonType.noThanks
            : processButtonType.none
          : processButtonType.none;
      break;
    case configuratorStep.upsellCustomization:
      backButtonType =
        upsellType === UpsellType.optional
          ? !askIfUserNeedUpsellImprintText
            ? processButtonType.noThanks
            : processButtonType.noWantAddText
          : !askIfUserNeedUpsellImprintText
          ? processButtonType.none
          : processButtonType.noWantAddText;
      break;
    default:
      backButtonType = processButtonType.none;
      break;
  }
  return backButtonType;
};
export const getNextButtonText = (nextButtonDisplayConditions) => {
  return processButtonDict[getNextButtonType(nextButtonDisplayConditions)][0];
};

export const getNextTextFinalization = (isAdminEditReorder) =>
  isAdminEditReorder ? processButtonType.returnToAdmin : processButtonType.addToCart;

export const getJumpUrl = ({ webAddress, priorityCode, linkType }) => {
  const getRedirectString = (page) => {
    if (!webAddress) {
      return '';
    } else {
      const delimiter = page.indexOf('?') > -1 ? '&' : '?';
      const coupon = priorityCode && priorityCode !== '' ? `${delimiter}coupon=${priorityCode}` : '';
      return `${webAddress}${page}${coupon}`;
    }
  };
  let url = '';
  switch (linkType) {
    case jumpLinkType.MyAccount:
      url = getRedirectString(pageUrl.MyAccount);
      break;
    case jumpLinkType.OrderTracking:
      url = getRedirectString(pageUrl.OrderTracking);
      break;
    case jumpLinkType.MySavedProject:
      url = getRedirectString(pageUrl.MySavedProject);
      break;
    case jumpLinkType.MyWishList:
      url = getRedirectString(pageUrl.MyWishList);
      break;
    case jumpLinkType.QuickReorder:
      url = getRedirectString(pageUrl.QuickReorder);
      break;
    case jumpLinkType.MyInvoice:
      url = getRedirectString(pageUrl.MyInvoice);
      break;
    case jumpLinkType.ShoppingCart:
      url = getRedirectString(pageUrl.ShoppingCart);
      break;
    case jumpLinkType.WindmillArtworkGuideLines:
      url = getRedirectString(pageUrl.WindmillArtworkGuideLines);
      break;
    case jumpLinkType.Sample:
      url = getRedirectString(pageUrl.Sample);
      break;
    case jumpLinkType.ResourceCenter:
      url = getRedirectString(pageUrl.ResourceCenter);
      break;
    case jumpLinkType.MultilineReps:
      url = getRedirectString(pageUrl.MultilineReps);
      break;
    case jumpLinkType.CustomerService:
      url = getRedirectString(pageUrl.CustomerService);
      break;
    case jumpLinkType.ContactUs:
      url = getRedirectString(pageUrl.ContactUs);
      break;
    case jumpLinkType.AboutUs:
      url = getRedirectString(pageUrl.AboutUs);
      break;
    case jumpLinkType.Favorites:
      url = getRedirectString(pageUrl.Favorites);
      break;
    default:
      break;
  }
  return url;
};

export const getConfiguratorAction = (action) => {
  let actionValue = action && action.toLowerCase();
  let type = configuratorAction.new;
  switch (actionValue) {
    case ACTION_NEW:
      type = configuratorAction.new;
      break;
    case ACTION_EDIT:
      type = configuratorAction.edit;
      break;
    case ACTION_REORDEREDIT:
      type = configuratorAction.reorderEdit;
      break;
    case ACTION_DESIGNLATER:
      type = configuratorAction.designLater;
      break;
    case ACTION_EDITTEMPLATE:
      type = configuratorAction.editTemplate;
      break;
    case ACTION_EDITCARTUPSELLS:
      type = configuratorAction.editCartUpsells;
      break;
    case ACTION_SHIPPING:
      type = configuratorAction.shipping;
      break;
    case ACTION_VIRTUALPROOF:
      type = configuratorAction.virtualProof;
      break;
    default:
      type = configuratorAction.new;
      break;
  }
  return type;
};

export const checkIfNeedToUpdatePricingForYearOptions = (state) => {
  let result = YearOptionPricingType.Ignored;

  const uiType = getPromoStudioUITypeSelector(state);
  if (uiType === promoStudioUITypeValue.LiteUI) return result;

  const question = getQuestion(state, YearQuestionCode);
  if (!question || question.selectionType !== SelectionType.SINGLE) return result;

  const options = getUniqueOptions(state, question.code);
  if (
    !options ||
    options.length === 0 ||
    options.some((option) => option.yearOptionPricing === YearOptionPricingType.Ignored)
  )
    return result;

  const price = getPrice(state);
  const selectedOption = options.find((option) => option.isSelected);
  if (!!selectedOption) {
    if (selectedOption.yearOptionPricing === YearOptionPricingType.OnRegular && price.isCouponApplied) {
      result = YearOptionPricingType.OnRegular;
    } else if (selectedOption.yearOptionPricing === YearOptionPricingType.OnSale && !price.isCouponApplied) {
      result = YearOptionPricingType.OnSale;
    }
  } else {
    if (!price.isCouponApplied) result = YearOptionPricingType.OnSale;
  }
  return result;
};

export const updatePricingIfNeededForYearOptions = () => {
  return (dispatch, getState) => {
    const state = getState();

    const pricingType = checkIfNeedToUpdatePricingForYearOptions(state);
    if (pricingType === YearOptionPricingType.Ignored) return;

    const pricingRequest = {
      coupon: pricingType === YearOptionPricingType.OnSale ? getCoupon(state) : '',
      displayItemSku: getDisplayItemSku(state),
      isSample: getSample(state),
      itemId: getItemId(state),
      priceSvcUrl: getPriceSvcUrl(state),
      token: getToken(state),
      vendorId: getVendorId(state),
      refId: getRefId(state),
    };
    dispatch(showWaitingCover());
    return getPricingData(pricingRequest)
      .then((response) => {
        dispatch(initializePrice(response.data.price));
        dispatch(initializeCharges(response.data.charges));
        dispatch(hideWaitingCover());
      })
      .catch((error) => {
        dispatch(catchErrorInfo(error));
        dispatch(setCurrentStep(configuratorStep.error));
        dispatch(hideWaitingCover());
      });
  };
};

export const initializeVendorAsync = (vendorid) => {
  return (dispatch) => {
    return getVendor(vendorid)
      .then((response) => {
        dispatch(initializeVendor(response.data));
      })
      .catch((_) => {});
  };
};
export const getVendorDict = (key) => {
  const param = new URLSearchParams(window.location.search.toLowerCase());
  const vendorid = param.get(PARAMETER_VENDORID.toLowerCase());
  return vendorDict[vendorid] && vendorDict[vendorid][key];
};
export const getHostVendorDict = (key) => {
  const hostname = window.location.hostname.toUpperCase();
  if (hostname.indexOf('AMSTERDAMPRINTING') > -1) {
    return hostVendorDict['AMSTERDAM'] && hostVendorDict['AMSTERDAM'][key];
  } else if (hostname.indexOf('AMSTERDAMPRODUCTS') > -1) {
    return hostVendorDict['AMSTERDAMPRODUCTS'] && hostVendorDict['AMSTERDAMPRODUCTS'][key];
  } else if (hostname.indexOf('BALDWINCOOK') > -1) {
    return hostVendorDict['BALDWINCOOK'] && hostVendorDict['BALDWINCOOK'][key];
  } else if (hostname.indexOf('USDIARY') > -1) {
    return hostVendorDict['USDIARY'] && hostVendorDict['USDIARY'][key];
  } else if (hostname.indexOf('TAYLORCOMMUNICATIONS') > -1) {
    return hostVendorDict['TAYLORCOMMUNICATIONS'] && hostVendorDict['TAYLORCOMMUNICATIONS'][key];
  } else if (hostname.indexOf('ADGPROMO') > -1) {
    return hostVendorDict['WINDMILL'] && hostVendorDict['WINDMILL'][key];
  } else if (hostname.indexOf('WINDMILLCANADA') > -1) {
    return hostVendorDict['WINDMILLCANADA'] && hostVendorDict['WINDMILLCANADA'][key];
  } else if (hostname.indexOf('CORDIALGREETINGS') > -1) {
    return hostVendorDict['CORDIALGREETINGS'] && hostVendorDict['CORDIALGREETINGS'][key];
  } else {
    return null;
  }
};
export const getVendorIdFromUri = () => {
  const param = new URLSearchParams(window.location.search.toLowerCase());
  const vendorid = param.get(PARAMETER_VENDORID.toLowerCase());
  return parseInt(vendorid);
};
export const getVendorIdByHostname = () => {
  const hostname = window.location.hostname.toUpperCase();
  if (hostname.indexOf('AMSTERDAMPRINTING') > -1) {
    return vendorId.Amsterdam;
  } else if (hostname.indexOf('AMSTERDAMPRODUCTS') > -1) {
    return vendorId.AmsterdamProducts;
  } else if (hostname.indexOf('BALDWINCOOK') > -1) {
    return vendorId.BaldwinCooke;
  } else if (hostname.indexOf('USDIARY') > -1) {
    return vendorId.USDiary;
  } else if (hostname.indexOf('TAYLORCOMMUNICATIONS') > -1) {
    return vendorId.TaylorCommunications;
  } else if (hostname.indexOf('ADGPROMO') > -1) {
    return vendorId.Windmill;
  } else if (hostname.indexOf('WINDMILLCANADA') > -1) {
    return vendorId.WindmillCanada;
  } else {
    return null;
  }
};

export const checkHasHeaderForNonDirectSites = () => {
  const vendorid = getVendorIdFromUri() || getVendorIdByHostname();
  return [vendorId.CGI, vendorId.SuperiorEnergy, vendorId.TC_Demo_Site].findIndex((x) => x === vendorid) > -1;
};

export const setParameterTokenAsync = (token) => {
  return (dispatch) => {
    dispatch(setParameterToken(token));
  };
};

export const tokenActionAsync = (action) => {
  return (dispatch, getState) => {
    const store = getState();
    const currentStep = getCurrentStep(store);
    currentStep !== configuratorStep.error && dispatch(action);
  };
};

export const parametersFormat = (params) => {
  let parameters = {};
  if (params && typeof params === 'object') {
    Object.keys(params).forEach((key) => {
      let index = parameterName.findIndex((x) => x.toLowerCase() === key.toLowerCase());
      if (index > -1) {
        let parameterValue = params[key];
        if (parameterName[index] === PARAMETER_SAMPLE) {
          if (parameterValue === TRUE) parameterValue = true;
          else parameterValue = false;
        } else if (parameterName[index] === PARAMETER_RETURNURL || parameterName[index] === PARAMETER_ITEMSKU) {
          parameterValue = decodeURIComponent(parameterValue);
        }
        if (parameterValue === undefined || parameterValue === null) parameterValue = '';
        parameters[parameterName[index]] = parameterValue;
      }
    });
  }

  return parameters;
};
export const getTokenAsync = (tokenRequest, action, reject) =>
  getTokenApi(tokenRequest)
    .then((response) => {
      if (response && response.headers) action && action();
    })
    .catch((_) => {
      reject && reject();
    });

export const checkReturnUrlValid = ({ returnUrl, successCallback }) => {
  return (dispatch) => {
    return checkReturnUrl(returnUrl)
      .then((response) => {
        const isReturnUrlValid = response.data;
        dispatch(isValidReturnUrl(isReturnUrlValid));
        if (isReturnUrlValid) {
          successCallback && successCallback();
        } else {
          dispatch(setCurrentStep(configuratorStep.error));
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch(setCurrentStep(configuratorStep.error));
      });
  };
};

export const parametersValidation = (params, isForCartUpsells = false, isTemplateEditor = false) => {
  const res = { success: true, message: '' };
  const paraKeys = (
    isForCartUpsells
      ? [
          PARAMETER_ITEMSKU,
          PARAMETER_REFID,
          PARAMETER_SESSIONID,
          PARAMETER_SHOPPINGCARTID,
          PARAMETER_STATUS,
          PARAMETER_VENDORID,
        ]
      : isTemplateEditor
      ? [PARAMETER_ITEMSKU, PARAMETER_VENDORID, PARAMETER_IMPRINTAREACODE, PARAMETER_IMPRINTLOCATION]
      : [
          PARAMETER_ITEMSKU,
          //navink site must be [PARAMETER_PRICESVCURL]
          params[PARAMETER_RETURNURL] &&
            params[PARAMETER_RETURNURL].toUpperCase() === NAVINK_RETURNURL &&
            PARAMETER_PRICESVCURL,
          PARAMETER_REFID,
          PARAMETER_RETURNURL,
          PARAMETER_STATUS,
          params[PARAMETER_RETURNURL] &&
            params[PARAMETER_RETURNURL].toUpperCase() === NAVINK_RETURNURL &&
            (process.env.REACT_APP_BUILD_ENV === 'staging' || process.env.REACT_APP_BUILD_ENV === 'production') &&
            PARAMETER_TOKEN,
          PARAMETER_VENDORID,
        ]
  ).filter(Boolean);

  for (const key of paraKeys) {
    if (!params[key]) {
      res.success = false;
      res.message = `{parameters.${key}} is required! `;
      break;
    }
  }

  return res;
};

/**
  options will change by users choosing
  usage:
  dispatch(
    imprintOptionUISetAsync([formatkey], () => ({
      textColor: color,
    }))
  );
 */
export const imprintOptionUISetAsync = (allSelectedKeys, getOptions) => (dispatch, getState) => {
  const state = getState();
  const imprintOptionUI = Object.assign({}, state.ui.imprintOption);
  allSelectedKeys.map((key) => {
    imprintOptionUI[key] = imprintOptionUI[key] || {};
    imprintOptionUI[key] = Object.assign(
      {},
      { ...imprintOptionUI[key] },
      {
        ...getOptions(state, key),
      }
    );
    return true;
  });
  dispatch(imprintOptionUISet(imprintOptionUI));
};

/**
  options will change on longer
  usage:
  dispatch(
    imprintOptionUIInitializeAsync([currentFormatKey], (state, key) => {
      const allTextLayout = getSelectedImprintLocation(state);
      return {
        logoLayout: allLogoLayout[key],
      };
    })
  );
 */
export const imprintOptionUIInitializeAsync = (allSelectedKeys, options) => (dispatch, getState) => {
  const state = getState();
  const imprintOptionUI = state.ui.imprintOption;
  const optionKeys = Object.keys(options);
  allSelectedKeys.forEach((key) => {
    optionKeys.forEach((opt) => {
      if (imprintOptionUI[key] === undefined || imprintOptionUI[key][opt] === undefined) {
        if (typeof options[opt] !== 'function') {
          throw new Error('options[value] must be function type');
        }
        const option = {};
        option[opt] = options[opt](state, key);
        dispatch(imprintOptionUIInitialize({ formatkey: key, option }));
      }
    });
  });
};

let postXmlLogic = null;
export const setPostXmlLogic = (func) => {
  postXmlLogic = func;
};

let rootElement = null;
export const setRootElement = (_dom) => {
  rootElement = _dom;
};
export const getRootElement = () => {
  return rootElement;
};

/**
 * @name userImagePrepare
 * prepare for UserImage Loading
 */
export const userImagePrepare = () => (dispatch, getState) => {
  const state = getState();
  const effectiveAreas = getTempSelectedImprintAreas(state).filter((x) => !getUserImageSetupCheck(state, x.key));
  if (effectiveAreas.length > 0) {
    dispatch(recordUserImageSetupAsync(effectiveAreas.map((x) => x.key)));
    const userImageAccess = getUserImageAccess(state);
    const stockArtCategories = state.stockArtCategoryDict;
    const sharedArtDict = getSharedArtDictSelector(state);
    const savedArtDict = getSavedArtDictSelector(state);
    const parameters = getParameters(state);
    const itemId = getItemId(state);
    const user = getUser(state);
    const isNextGenUI = getIsNextGenUI(state);
    const offerLogo = (formatkey) => getImprintOptionOfferLogo(getState(), formatkey);
    //StockArt Categories
    dispatch(() => {
      if (userImageAccess.stock) {
        effectiveAreas.forEach((format, _) => {
          if (offerLogo(format.key)) {
            if (!stockArtCategories[format.imprintAreaCode]) {
              dispatch(getStockArtCategories(parameters.vendorId, format));
            }
          }
        });
      }
    });

    //SloganList
    dispatch(() => {
      if (userImageAccess.slogan) {
        for (const item of effectiveAreas) {
          if (getImprintOptionOfferSlogan(state, item.key)) {
            const sloganDict = getState().sloganDict;
            if (
              !(
                sloganDict &&
                sloganDict[item.imprintAreaCode] &&
                sloganDict[item.imprintAreaCode].slogans &&
                sloganDict[item.imprintAreaCode].slogans.length > 0
              )
            ) {
              dispatch(getSloganList(item.imprintAreaCode, parameters.vendorId));
            }
          }
        }
      }
    });

    //Verse
    dispatch(() => {
      if (userImageAccess.verse) {
        const verseList = getVerseListSelector(state);
        if (verseList.length === 0) {
          dispatch(getVerseList);
        }
      }
    });

    //Sentiment
    dispatch(() => {
      if (userImageAccess.verse) {
        const sentimentList = getSentimentListSelector(state);
        if (sentimentList.length === 0) {
          dispatch(getSentimentList);
        }
      }
    });

    //SharedArt
    dispatch(() => {
      if (userImageAccess.shared) {
        effectiveAreas.forEach((format, _) => {
          if (offerLogo(format.key)) {
            const sharedkey = format.key;
            if (
              !(sharedArtDict && sharedArtDict[sharedkey]) ||
              (sharedArtDict[sharedkey].list && sharedArtDict[sharedkey].list.length === 0)
            ) {
              dispatch(
                getSharedArtList(parameters.vendorId, itemId, format.processType, format.imprintAreaCode, format.key)
              );
            }
          }
        });
      }
    });

    //SavedArt
    dispatch(() => {
      if (userImageAccess.saved && user) {
        effectiveAreas.forEach((format, _) => {
          if (offerLogo(format.key)) {
            const savedKey = `${format.imprintAreaCode}-${format.processType}`;
            if (!(savedArtDict && savedArtDict[savedKey] && savedArtDict[savedKey].count > 0)) {
              dispatch(setSavedArtList(format.processType, format.imprintAreaCode));
            }
          }
        });
      }
    });
  }
};

export const mobileSide2GuideStartAsync = () => (dispatch, getState) => {
  const state = getState();
  const storeData = getSidebarStoreData(state);
  const allowedIcons = getAllowedIcons(state);
  const isGuideMode = getCurrentGuideModeCheck(state);
  if (isGuideMode && allowedIcons.filter((x) => x !== sidebarTabKeyEnum.Preview).length > 0) {
    changeSideBarKey({
      dispatch,
      newKey: allowedIcons.filter((x) => x !== sidebarTabKeyEnum.Preview)[0],
      ...storeData,
    });
  }
};

export const initializeCartUpsellsAsync = () => (dispatch, getState) => {
  const state = getState();
  const parameters = getParameters(state);

  const tokenRequest = {
    acctId: parameters[PARAMETER_ACCTID] || '',
    contactNumber: Number.isInteger(Number(parameters[PARAMETER_CONTACTNUMBER]))
      ? Number(parameters[PARAMETER_CONTACTNUMBER])
      : 0,
    sessionId: parameters[PARAMETER_SESSIONID] || '',
  };

  dispatch(showWaitingCover());
  getTokenAsync(tokenRequest, () => {
    const cartUpsellsRequest = {
      itemId: parameters[PARAMETER_ITEMSKU],
      refId: parameters[PARAMETER_REFID],
      status: parameters[PARAMETER_STATUS],
      vendorId: parameters[PARAMETER_VENDORID],
    };
    if (parameters[PARAMETER_COMPANYNAME]) {
      cartUpsellsRequest[PARAMETER_COMPANYNAME] = parameters[PARAMETER_COMPANYNAME];
    }
    if (parameters[PARAMETER_COUPON]) {
      cartUpsellsRequest[PARAMETER_COUPON] = parameters[PARAMETER_COUPON];
    }
    if (parameters[PARAMETER_REQUIREDUPSELLITEMID]) {
      cartUpsellsRequest[PARAMETER_REQUIREDUPSELLITEMID] = parameters[PARAMETER_REQUIREDUPSELLITEMID];
    }
    if (parameters[PARAMETER_REQUIREDUPSELLSONLY]) {
      cartUpsellsRequest[PARAMETER_REQUIREDUPSELLSONLY] = parameters[PARAMETER_REQUIREDUPSELLSONLY];
    }
    if (parameters[PARAMETER_ZIP]) {
      cartUpsellsRequest[PARAMETER_ZIP] = parameters[PARAMETER_ZIP];
    }
    dispatch(initializeCartUpsellsData(cartUpsellsRequest));
  });
};

export const updateCartUpsells = (successCallback, failureCallback) => (dispatch, getState) => {
  const state = getState();
  const parameters = getParameters(state);
  const selectedUpsells = getSelectedUpsells(state);
  const request = {
    refId: parameters[PARAMETER_REFID],
    shoppingCartId: parameters[PARAMETER_SHOPPINGCARTID],
    upsellItems: selectedUpsells,
    vendorId: parameters[PARAMETER_VENDORID],
  };
  if (parameters[PARAMETER_COUPON]) {
    request[PARAMETER_COUPON] = parameters[PARAMETER_COUPON];
  }
  if (parameters[PARAMETER_ZIP]) {
    request[PARAMETER_ZIP] = parameters[PARAMETER_ZIP];
  }

  return updateCartUpsellsData(request)
    .then(() => {
      dispatch(hideWaitingCover());
      if (successCallback && typeof successCallback === 'function') {
        successCallback();
      }
    })
    .catch((error) => {
      dispatch(catchErrorInfo(error));
      dispatch(setCurrentStep(configuratorStep.error));
      dispatch(hideWaitingCover());
      if (failureCallback && typeof failureCallback === 'function') {
        failureCallback();
      }
    });
};

const exceptionHandling = ({ error, reject }) => {
  reject &&
    reject(
      error.response &&
        error.response.data &&
        error.response.data.internalCode &&
        error.response.data.additionalInfo && {
          code: error.response.data.internalCode,
          info: error.response.data.additionalInfo,
        }
    );
};

export const catchErrorInfo =
  ({ message, stack }) =>
  (_, getState) => {
    if (message && !errorInfoExclude.includes(message)) {
      recordErrorInfo({
        baseError: message,
        stackTrace: stack,
        urlParameter: getParameters(getState()),
      }).catch((error) => console.error(error));
    }
  };

export const promoStudioUITypeData = (action, uiTypeRequest, request, editItem) => {
  return (dispatch) => {
    return getPromoStudioUIType(uiTypeRequest)
      .then(function (response) {
        if (response.data !== '') {
          const promoStudioUIType = response.data.promoStudioUIType;
          const genProduct = response.data.nextGenUI;
          const isMainItem = response.data.isMainItem;
          const noUIMessage = 'The product is currently configured with NoUI';
          if (
            action === configuratorAction.new ||
            action === configuratorAction.designLater ||
            action === configuratorAction.virtualProof
          ) {
            if (promoStudioUIType === promoStudioUITypeValue.FullUI) {
              if (genProduct) {
                dispatch(initializeAllForGenProduct(request));
                dispatch(initializeImprintThumbnails(request.vendorId, request.itemId));
                registerFontFamily(request.vendorId, request.itemId);
              } else {
                dispatch(initializeStep1Data(request));
              }
            } else if (promoStudioUIType === promoStudioUITypeValue.LiteUI) {
              if (isMainItem) {
                dispatch(initializeLiteBomOptionsData(request));
              } else {
                dispatch(initializeLiteData(uiTypeRequest, request, isMainItem));
              }
            } else if (promoStudioUIType === promoStudioUITypeValue.NoUI) {
              dispatch(
                showMessageBox({
                  show: true,
                  message: noUIMessage,
                })
              );
              dispatch(hideWaitingCover());
            }
          } else {
            if (promoStudioUIType === promoStudioUITypeValue.FullUI) {
              dispatch(initializeCartData(request, editItem));
              if (genProduct) {
                dispatch(initializeImprintThumbnails(request.vendorId, request.itemId));
                registerFontFamily(request.vendorId, request.itemId);
              }
            } else if (promoStudioUIType === promoStudioUITypeValue.LiteUI) {
              dispatch(initializeLiteCartData(uiTypeRequest, request));
            } else if (promoStudioUIType === promoStudioUITypeValue.NoUI) {
              dispatch(
                showMessageBox({
                  show: true,
                  message: noUIMessage,
                })
              );
              dispatch(hideWaitingCover());
            }
          }
        } else {
          dispatch(
            showMessageBox({
              show: true,
              message: ITEM_CANNOT_CUSTOMIZED,
              hasCloseButton: false,
              onOk: () => {
                dispatch(go(-1));
              },
            })
          );
          dispatch(hideWaitingCover());
        }
      })
      .catch(function (error) {
        dispatch(catchErrorInfo(error));
        dispatch(setCurrentStep(configuratorStep.error));
        dispatch(hideWaitingCover());
      });
  };
};

export const getScene7StockImageModeAsync = (bomOption) => {
  return (dispatch, getState) => {
    const state = getState();
    const key = `${bomOption.code}-${bomOption.codeValue}`;
    const stockImageTypeDict = getStockImageTypeDict(state);

    if (
      !Object.keys(stockImageTypeDict).includes(key) ||
      !Object.values(scene7StockImageMode).includes(stockImageTypeDict[key])
    ) {
      const itemId = getItemId(state);
      const twinItemId = getTwinItemId(state);
      const vendorId = getVendorId(state);
      const request = {
        code: bomOption.code,
        codeValue: bomOption.codeValue,
        itemId,
        twinItemId,
        vendorId,
        useTexture: bomOption.useTexture,
      };

      getScene7StockImageModeData(request)
        .then((response) => {
          dispatch(backupStockImageType({ key, stockImageType: response.data }));
        })
        .catch((error) => {
          dispatch(catchErrorInfo(error));
        });
    }
  };
};

export const initializeMainAsync = (parameters, bomOptionsFullData) => (dispatch, getState) => {
  dispatch(showWaitingCover());
  const tokenRequest = {
    acctId: parameters[PARAMETER_ACCTID] || '',
    contactNumber: Number.isInteger(Number(parameters[PARAMETER_CONTACTNUMBER]))
      ? Number(parameters[PARAMETER_CONTACTNUMBER])
      : 0,
    sessionId: parameters[PARAMETER_SESSIONID] || '',
  };
  getTokenAsync(
    tokenRequest,
    () => {
      const successCallback = function () {
        let request = {
          vendorId: parameters[PARAMETER_VENDORID],
          itemId: parameters[PARAMETER_ITEMSKU],
          priceSvcUrl: parameters[PARAMETER_PRICESVCURL],
          token: parameters[PARAMETER_TOKEN],
          coupon: parameters[PARAMETER_COUPON],
          displayItemSku: parameters[PARAMETER_DISPLAYITEMSKU],
          isSample: parameters[PARAMETER_SAMPLE],
          templateId: parameters[PARAMETER_TEMPLATEID],
          status: parameters[PARAMETER_STATUS],
          refId: parameters[PARAMETER_REFID],
        };
        let uiTypeRequest = {
          vendorId: parameters[PARAMETER_VENDORID],
          itemId: parameters[PARAMETER_ITEMSKU],
          isSample: parameters[PARAMETER_SAMPLE],
        };

        let action = getConfiguratorAction(parameters[PARAMETER_STATUS]);
        const isBomOptionsPackageContext = getWhetherCurrentContextIsBomOptionsPackage(getState());
        if (isBomOptionsPackageContext) {
          if (!!bomOptionsFullData) {
            try {
              initializeBomOptionsDataHelper(dispatch, getState, { data: bomOptionsFullData });
            } catch (error) {
              dispatch(catchErrorInfo(error));
              dispatch(setCurrentStep(configuratorStep.error));
              dispatch(hideWaitingCover());
              dispatchBomOptionsErrorEvent(error);
            }
          } else {
            dispatch(initializeBomOptionsData(request));
          }
        } else {
          if (action === configuratorAction.new || action === configuratorAction.designLater) {
            let step1Request = request;
            dispatch(promoStudioUITypeData(action, uiTypeRequest, step1Request));
          } else {
            let cartQueryRequest = request;
            //cartQueryRequest[PARAMETER_REFID] = parameters[PARAMETER_REFID];
            //cartQueryRequest[PARAMETER_STATUS] = parameters[PARAMETER_STATUS];
            //for reorder
            cartQueryRequest[PARAMETER_OLDCONFIGID_KEY] = parameters[PARAMETER_OLDCONFIGID];
            cartQueryRequest[PARAMETER_ZIP] = parameters[PARAMETER_ZIP];
            cartQueryRequest[PARAMETER_INTCMP] = parameters[PARAMETER_INTCMP];
            cartQueryRequest[PARAMETER_SCID] = parameters[PARAMETER_SCID];
            cartQueryRequest[PARAMETER_RETURNURL] = parameters[PARAMETER_RETURNURL];
            cartQueryRequest[PARAMETER_ISAS400REORDER] = parameters[PARAMETER_ISAS400REORDER];
            cartQueryRequest[PARAMETER_ORDERID] = parameters[PARAMETER_ORDERID];
            cartQueryRequest[PARAMETER_ORDERSEQUENCE] = parameters[PARAMETER_ORDERSEQUENCE];
            cartQueryRequest[PARAMETER_EXACTREORDER] = parameters[PARAMETER_EXACTREORDER];
            cartQueryRequest[PARAMETER_REP] = parameters[PARAMETER_REP];
            let editItem = '';
            if (action === configuratorAction.edit) {
              if (Object.keys(parameters).indexOf(PARAMETER_EDITITEM) > -1) {
                editItem = parameters[PARAMETER_EDITITEM];
              }
            }
            dispatch(promoStudioUITypeData(action, uiTypeRequest, cartQueryRequest, editItem));
          }
        }
      };

      dispatch(
        checkReturnUrlValid({
          returnUrl: parameters.returnUrl,
          successCallback,
        })
      );
    },
    () => {
      dispatch(setCurrentStep(configuratorStep.error));
    }
  );
};

export const initializeBomOptionsAsync = (parameters, bomOptionsFullData) => (dispatch, getState) => {
  dispatch(showWaitingCover());
  dispatch(
    checkReturnUrlValid({
      returnUrl: parameters.returnUrl,
      successCallback: () => {
        const state = getState();
        const isBomOptionsPackageContext = getWhetherCurrentContextIsBomOptionsPackage(state);
        try {
          initializeBomOptionsDataHelper(dispatch, getState, { data: bomOptionsFullData });
        } catch (error) {
          dispatch(catchErrorInfo(error));
          dispatch(setCurrentStep(configuratorStep.error));
          dispatch(hideWaitingCover());
          if (isBomOptionsPackageContext) {
            dispatchBomOptionsErrorEvent(error);
          }
        }
      },
    })
  );
};

export const checkForES6Support = () => {
  try {
    return new Function('(a = 0) => a'), !0;
  } catch (r) {
    return !1;
  }
};
export const changeFaviconForInternalBrand = (vendorId) => {
  const isAplInternalBrand = internalBrands.indexOf(vendorId) > -1;
  if (isAplInternalBrand) {
    const favicon = document.getElementById('favicon');
    if (favicon) {
      favicon.href = RESOURCES_PATH + vendorDict[vendorId].rootDir + vendorDict[vendorId].favicon;
    }
  }
};

export const closeExternalWaitingCover = () => (dispatch, getState) => {
  const externalWaitingCoverId = getExternalWaitingCoverId(getState());
  closeExternalWaitingCoverById(externalWaitingCoverId);
};

export const closeExternalWaitingCoverById = (externalWaitingCoverId) => {
  if (externalWaitingCoverId !== '' && document.getElementById(externalWaitingCoverId)) {
    document.getElementById(externalWaitingCoverId).removeAttribute('show');
  }
};

export const getNextStepEvent = (props) => {
  const { currentStep, delegate, nextButtonType, allowDesignLater, hasUpsells, upsellsSelectedItems } = props;
  let onClickFunc = () => {};
  let nextBtnEventText = '';
  switch (currentStep) {
    case configuratorStep.bom:
      nextBtnEventText =
        nextButtonType === processButtonType.addToCart
          ? allowDesignLater
            ? nextBtnEvent.designServiceAddToCart
            : nextBtnEvent.productOptionsAddtoCart
          : nextBtnEvent.productOptionsNext;
      onClickFunc = GoogleTagManager(() => delegate(currentStep), nextBtnEventText);
      if (nextButtonType === processButtonType.addToCart && hasUpsells)
        onClickFunc = GoogleTagManager(onClickFunc, nextBtnEvent.upsellPopup);
      break;
    case configuratorStep.imprintarea:
    case configuratorStep.imprintoption:
      nextBtnEventText =
        nextButtonType === processButtonType.addToCart
          ? nextBtnEvent.noImprintAddtoCart
          : nextBtnEvent.imprintOptionsNext;
      onClickFunc = GoogleTagManager(() => delegate(currentStep), nextBtnEventText);
      if (nextButtonType === processButtonType.addToCart && hasUpsells)
        onClickFunc = GoogleTagManager(onClickFunc, nextBtnEvent.upsellPopup);
      break;
    case configuratorStep.canvas:
      nextBtnEventText =
        nextButtonType === processButtonType.emailVirtualProof
          ? nextBtnEvent.emailVirtualProof
          : nextButtonType === processButtonType.addToCart
          ? nextBtnEvent.addToCart
          : nextBtnEvent.next;
      onClickFunc = GoogleTagManager(() => delegate(currentStep), nextBtnEventText);
      if (nextButtonType === processButtonType.addToCart && hasUpsells)
        onClickFunc = GoogleTagManager(onClickFunc, nextBtnEvent.upsellPopup);
      break;
    case configuratorStep.upsell:
      nextBtnEventText =
        nextButtonType === processButtonType.addToCart
          ? upsellsSelectedItems
            ? nextBtnEvent.upsellAddtoCartwithItem
            : nextBtnEvent.upsellAddtoCart
          : nextBtnEvent.upsellPopup;
      const eventParamter =
        nextBtnEventText === nextBtnEvent.upsellAddtoCartwithItem
          ? {
              upsellItem: upsellsSelectedItems,
            }
          : null;
      onClickFunc = GoogleTagManager(() => delegate(currentStep), nextBtnEventText, eventParamter);
      break;
    case configuratorStep.upsellCustomization:
      onClickFunc =
        nextButtonType === processButtonType.addToCart
          ? GoogleTagManager(() => delegate(currentStep), nextBtnEvent.upsellAddtoCartwithItem, {
              upsellItem: upsellsSelectedItems,
            })
          : nextButtonType === processButtonType.personalizeAndAddToCart
          ? (onClickFunc = GoogleTagManager(() => delegate(currentStep), nextBtnEvent.upsellPopup))
          : delegate;
      break;
    default:
      onClickFunc = delegate;
      break;
  }
  return onClickFunc();
};

export const sendChatEmail = (chatInfo) => (dispatch) => {
  sendOfflineChatEmail(chatInfo)
    .then((response) => {
      if (response.data) {
        dispatch(finishOfflineChat());
      } else {
        dispatch(sendOfflineChatError('Failed to send Email.'));
      }
    })
    .catch((error) => {
      dispatch(sendOfflineChatError(error.response.data.additionalInfo));
    });
};
